/* Casemira, guide des tailles en tiroir, fiches hors couloir. R5, 05/09/2026.
   Direction : AUDIT-GUIDE-TAILLES.md § 4. Le RAISONNEMENT COMPLET (contrat de
   lecture § 4.1, les quatre corrections du portage, les trois gardes, le
   verrou) vit dans l'en-tete de `snippets/casemira-guide-tailles.liquid` :
   un commentaire Liquid est retire au rendu, celui-ci part sur le reseau. */
(function () {
  'use strict';

  var racine = document.documentElement;

  /* La palette passe en jetons de `casemira-tokens.css`, lus une fois. Les SVG
     recoivent des couleurs RESOLUES, pas des `var()` : un attribut de
     presentation SVG ne les resout pas partout. */
  function jeton(nom, repli) {
    try {
      var v = getComputedStyle(racine).getPropertyValue(nom).trim();
      return v || repli;
    } catch (e) { return repli; }
  }
  /* LUE A LA PREMIERE DEMANDE (revue G14, mineur 5) : ces sept
     `getComputedStyle` etaient faits au chargement, pour un panneau que la
     plupart des visiteurs n'ouvrent pas. `render()` est le seul appelant et les
     demande a son premier dessin ; l'objet est rempli une fois, les lecteurs
     gardent leur `C.rug`. */
  var C = {};
  var palettePosee = false;
  function palette() {
    if (palettePosee) return C;
    palettePosee = true;
    C.rug = jeton('--cm-sand', '#F8F7F5');
    C.rugline = jeton('--cm-rule-strong', '#D6CDBD');
    C.furn = jeton('--cm-ink-muted', '#56606E');
    C.furnFill = jeton('--cm-paper', '#FFFFFF');
    C.dim = jeton('--cm-ink-muted', '#56606E');
    C.gold = jeton('--cm-focus-ring', '#795F24');
    C.soft = jeton('--cm-rule', '#E3DCCF');
    return C;
  }

  /* DEUX MODES, UN SEUL MOTEUR (G14). `demarre()` sert le TIROIR des fiches
     (une instance, panneau hors flux) et le MODE PAGE de
     /pages/guide-des-tailles (plusieurs instances, rendu a plat, sans
     dialogue ni voile ni verrou ni historique ni geste). Les six branches
     `PAGE` sont ecrites la ou la difference se produit ; la sortie du mode
     page est un `return` unique, juste avant le bloc « OUVERTURE, FERMETURE,
     VERROU ». LE RAISONNEMENT COMPLET vit dans l'en-tete Liquid de
     `sections/cm-guide-tailles.liquid`, § « LES DEUX MOTEURS EN MODE PAGE » :
     un commentaire Liquid est retire au rendu, celui-ci part sur le reseau.
     L'INDENTATION DU CORPS NE BOUGE PAS : `g34-tiroir-ouvert.mjs` decoupe le
     corps de `applique()` sur la premiere fermeture a deux espaces. */
  function demarre(root, MODE) {
  var PAGE = (MODE === 'page');
  /* ── MODE BERBÈRE (25/09/2026) ─────────────────────────────────────────
     Tiroir du gabarit `product.berbere-sur-mesure`, rendu par
     `snippets/berbere-guide-tiroir.liquid`. Il n'y a PAS de sélecteur de
     formats : la sélection est la saisie du configurateur, lue EN DIRECT sur
     `#berbere-config` (`data-cm-largeur` en cm, `data-cm-longueur` en mètres,
     `data-cm-diametre` en cm), relue à chaque `berbere:change`. Les formats
     listés sont les tailles standard de la matrice, écrites par Liquid dans
     l'hôte (`[data-cmt-std]`, mêmes attributs que les lignes du sélecteur) ;
     un clic pose ces dimensions dans le configurateur par
     `couloir:set-dimensions`, le contrat du picker couloir. La saisie est
     insérée dans la rangée, à son rang de surface, pour la situer par rapport
     aux tailles conseillées. Aucun prix n'est affiché. Toutes les branches
     portent `BRB` : hors de ce gabarit, rien ne change. */
  var BRB = !PAGE && root.getAttribute('data-cm-source') === 'berbere';
  var cfg = BRB ? document.getElementById('berbere-config') : null;

  /* Garde du § 4.8, MODE TIROIR SEULEMENT : tiroir COULOIR present, on sort,
     car les deux composants partagent la classe de declencheur et ouvriraient
     deux panneaux. Elle ne devrait jamais servir, et c'est pour cela qu'elle
     est ecrite. En mode page il n'y a pas de declencheur : les deux moteurs
     cohabitent sur la meme page, chacun sur ses propres hotes. */
  if (!PAGE && document.getElementById('cm-guide-tiroir')) return;

  /* ── FILET G6.5 : LES DECLENCHEURS QUI N'ONT JAMAIS VU LE DRAPEAU ────────
     Le drapeau `cm_guide_tiroir_actif` voyage par trois `{% render %}` depuis
     la section. Un declencheur ecrit AILLEURS ne le recoit pas : c'est le cas
     de la fiche sous-couche, dont le configurateur est insere par un bloc
     `custom_liquid` du gabarit, et un bloc `custom_liquid` NE VOIT PAS les
     variables de la section (§ 4.3). Elle rend donc l'ancienne classe,
     `cm-guide-trigger`, et vise `#cm-guide-modal`.

     Tant que l'ancien modal existait, ce repli etait le bon. Depuis l'etape 3
     il n'existe plus : `openGuide()` de `casemira-pdp-reskin.js` sort a sa
     deuxieme ligne (`if (!md) return`), le bouton ne repond plus a rien, en
     silence. On adopte donc ces declencheurs, et SEULEMENT quand l'ancien
     modal est absent du document : le jour ou une branche le rendrait de
     nouveau, ce filet se retire tout seul et le vieux chemin reprend la main.

     Le geste est ecrit AVANT la garde de presence du selecteur, quelques
     lignes plus bas : un declencheur adopte doit aussi pouvoir etre masque. */
  if (!PAGE && !document.getElementById('cm-guide-modal')) {
    var orphelins = document.querySelectorAll('.cm-guide-trigger');
    for (var o = 0; o < orphelins.length; o++) {
      orphelins[o].classList.add('cm-guide-tiroir-trigger');
      orphelins[o].setAttribute('aria-controls', 'cm-guide-tailles');
    }
  }

  var panneau = root.querySelector('.cmt-panneau');
  var croix = root.querySelector('.cmt-croix');
  var boite = root.querySelector('[data-cmt-scene]');
  var elSel = root.querySelector('[data-cmt-sel]');
  var elVerdict = root.querySelector('.cmt-verdict');
  var elVerdictVal = root.querySelector('[data-cmt-verdict-val]');
  var elFormats = root.querySelector('[data-cmt-formats]');
  var elEpuise = root.querySelector('[data-cmt-epuise]');
  var blocFormats = root.querySelector('[data-cmt-bloc-formats]');
  var rangeePieces = root.querySelector('[data-cmt-pieces]');
  var elPrix = root.querySelector('[data-cmt-prix]');
  var elContinuer = root.querySelector('[data-cmt-continuer]');
  var pied = root.querySelector('[data-cmt-pied]');
  var legendeMarge = root.querySelector('[data-cmt-legende-marge]');
  /* MODE PAGE : le bouton « Voir les tapis », ecrit par Liquid avec l'adresse
     du format conseille et remis a jour a chaque format choisi. */
  var elLien = PAGE ? root.querySelector('[data-cmt-lien]') : null;

  var SEL_LIGNES = '.section-main-product .dw-picker__row[data-size-value]';

  /* Troisieme garde, § 4.3 « deuxieme couche » : Liquid ne voit pas qu'un
     gabarit rend son selecteur ailleurs ni qu'un bloc a ete desactive depuis
     l'editeur. Sans ligne de format, le declencheur disparait (etat E6). */
  /* MODE PAGE : LES PASTILLES SONT LES LIGNES. Elles portent les memes deux
     attributs que le selecteur de la fiche, `data-size-value` et
     `data-available`, ecrits par Liquid : tout ce qui lit une ligne plus bas
     (`analyse`, `dispo`, `libelleLigne`) fonctionne sans une branche de plus.
     La rangee est ecrite au premier octet, donc sans decalage et lisible par
     un moteur de recherche. */
  function lignes() {
    if (BRB) return Array.prototype.slice.call(root.querySelectorAll('[data-cmt-std][data-size-value]'));
    if (PAGE) return Array.prototype.slice.call(root.querySelectorAll('[data-cmt-fmt][data-size-value]'));
    return Array.prototype.slice.call(document.querySelectorAll(SEL_LIGNES));
  }
  if (!BRB && !lignes().length) {
    /* Mode page : rien a dessiner, et aucun declencheur a masquer. */
    if (PAGE) return;
    /* LES DEUX CLASSES, comme la facade : la fiche sous-couche ecrit encore
       l'ancienne, et depuis l'etape 3 elle n'a plus de modal de repli. Le
       `hidden` ne suffit pas seul, `theme.css` habille `button` en
       `display: inline-flex` : la regle qui le rend effectif est dans
       `casemira-guide-tailles.css`, hors `.cmt`. */
    var muets = document.querySelectorAll('.cm-guide-tiroir-trigger, .cm-guide-trigger');
    for (var q = 0; q < muets.length; q++) muets[q].hidden = true;
    return;
  }

  /* Ce que Liquid a resolu (§ 4.2). Le moteur garde les noms de forme de
     l'ancien fichier, que ses scenes testent tels quels : la table de
     correspondance vit ici, en un seul endroit. */
  /* G6.5 : `bain` est la cinquieme forme. Elle ne vient pas d'un tag `forme:`
     (les 106 kits portent tous `forme:Rectangle`) mais du tag « Tapis de Bain »,
     lu en Liquid. Un kit n'est pas un tapis de plus : c'est DEUX tapis, et la
     scene est une salle de bain, pas une piece a vivre. */
  var FORMES = { rect: 'rect', rond: 'round', ovale: 'oval', libre: 'organic', bain: 'bain' };
  var SHAPE = FORMES[root.getAttribute('data-cm-forme')] || 'rect';
  /* ── LE KIT DECOUPE EN U DES WC (G17b) ────────────────────────────────────
     Retour de Raph du 07/09 a 19h45 : « au bain tu dis petit devant lavabo,
     mais il y a aussi des WC : mes tapis decoupes en U pour les WC sont tous
     les SKU qui commencent par MONTU. » Le drapeau est resolu EN LIQUID, sur
     le SKU des variantes, et jamais ici : un SKU n'est pas traduit, un titre
     l'est (regle G6.5, meme raison que le tag « Tapis de Bain »). Le JS ne lit
     qu'un « 1 ». */
  var WC = root.getAttribute('data-cm-wc') === '1';
  var ORGANIC = root.getAttribute('data-cm-organique') === 'agata' ? 'agata' : 'circo';
  var ROOMS = (root.getAttribute('data-cm-pieces') || '').split(',').filter(Boolean);
  var DEPART = root.getAttribute('data-cm-piece-depart') || '';
  if (!ROOMS.length) ROOMS = ['salon', 'sam', 'chambre'];
  if (DEPART && ROOMS.indexOf(DEPART) > 0) {
    ROOMS = [DEPART].concat(ROOMS.filter(function (r) { return r !== DEPART; }));
  }

  function att(n) { return root.getAttribute('data-t-' + n) || ''; }
  var T = {
    conseille: att('conseille'),
    epuise: att('epuise'),
    /* « Continuer avec 200 × 300 cm ». Marqueur `[f]`, comme `[c]` et `[p]` du
       verdict chambre : le format n'existe pas au rendu serveur. */
    continuer: att('continuer'),
    salonTout: att('v-salon-tout'),
    salonAngle: att('v-salon-angle'),
    salonAvant: att('v-salon-avant'),
    salonPetit: att('v-salon-petit'),
    chambreOk: att('v-chambre-ok'),
    chambreJuste: att('v-chambre-juste'),
    chambreAvert: att('v-chambre-avert'),
    samOk: att('v-sam-ok'),
    samJuste: att('v-sam-juste'),
    samAvert: att('v-sam-avert'),
    entreeCouloir: att('v-entree-couloir'),
    entreePorte: att('v-entree-porte'),
    cuisine: att('v-cuisine'),
    loungeTout: att('v-lounge-tout'),
    loungeAvant: att('v-lounge-avant'),
    compact: att('v-compact'),
    /* La forme libre reutilise son premier repere comme verdict : il dit deja
       ce que disaient les deux verdicts organiques l.195 et l.196. */
    libre: att('v-libre'),
    /* Le verdict du kit de bain : il dit ou va chacun des deux tapis. */
    bain: att('v-bain'),
    /* Le nom accessible de la scene de bain, jetons `[g]` et `[p]`. */
    sceneBain: att('scene-bain'),
    /* G17b, les deux memes chaines pour la vue WC : le verdict dit ou va
       chacun des deux tapis quand le petit est decoupe en U, et le nom
       accessible dit ce que la scene montre, ce qu'un format ne dit pas. */
    wc: att('v-wc'),
    sceneWC: att('scene-wc'),
    /* G18a, 08/09 : les deux memes chaines pour la vue LAVABO d'un kit
       decoupe en U. Retour de Raph : « le U a deux positions : autour d'un
       lavabo sur pied (il epouse la colonne et cache la tuyauterie) ou autour
       des WC ». Les deux vues montrent donc le MEME tapis, au meme format,
       autour de deux pieds differents : elles ne peuvent pas partager une
       phrase, ni pour l'oeil ni pour un lecteur d'ecran. */
    lavabo: att('v-lavabo'),
    sceneLavabo: att('scene-lavabo')
  };
  function tpl(chaine, jetons) {
    var s = String(chaine || '');
    for (var k in jetons) {
      if (Object.prototype.hasOwnProperty.call(jetons, k)) s = s.split(k).join(jetons[k]);
    }
    return s;
  }

  /* MOTEUR DE SCENE, porte de `casemira-cm-size-guide.js` l.5 a 249. La
     trigonometrie ne bouge pas ; les quatre seules corrections autorisees sont
     listees dans l'en-tete Liquid. */


  var isRound = function (f) { return f && f.dia != null; };
  var dimsOf = function (f) { return isRound(f) ? { w: f.dia, l: f.dia } : { w: f.w, l: f.l }; };
  /* Le libelle d'un format vient du SELECTEUR, `.dw-picker__row-dim`, qui porte
     deja le signe multiplie pose par Liquid et l'unite dans la langue de la
     page. Le refabriquer ici, c'etait reinventer un formatage que le theme
     fait deja, et le faire diverger le jour ou le selecteur change le sien.
     Le repli n'est utilise que si la ligne n'a pas encore ete resolue. */
  var libelleFormat = function (f) {
    if (f && f.ligne) {
      var dim = f.ligne.querySelector('.dw-picker__row-dim');
      var t = ((dim ? dim.textContent : '') || '').trim();
      if (t) return t;
    }
    if (isRound(f)) return 'Ø' + f.dia + ' cm';
    /* Le repli d'un kit nomme SES DEUX TAPIS : dire « 50 × 80 cm » d'un kit
       « 50 x 80 + 40 x 50 cm », c'est en oublier la moitie. */
    if (f && f.kit) return f.w + ' × ' + f.l + ' + ' + f.kit.w + ' × ' + f.kit.l + ' cm';
    return f.w + ' × ' + f.l + ' cm';
  };

  function rug(f) {
    var d = dimsOf(f);
    return { t: 'rug', x: 0, y: 0, w: d.l, h: d.w, shape: SHAPE };
  }

  function bboxOf(p) {
    var x0 = 1e9, y0 = 1e9, x1 = -1e9, y1 = -1e9;
    var a = function (x, y) { x0 = Math.min(x0, x); y0 = Math.min(y0, y); x1 = Math.max(x1, x); y1 = Math.max(y1, y); };
    p.forEach(function (o) {
      if (o.t === 'rug' || o.t === 'furn') { a(o.x, o.y); a(o.x + o.w, o.y + o.h); }
      else if (o.t === 'dim' || o.t === 'deb') { a(o.x1, o.y1); a(o.x2, o.y2); }
    });
    var pad = 14;
    return { x0: x0 - pad, y0: y0 - pad, x1: x1 + pad, y1: y1 + pad };
  }

  function smoothClosed(pts) {
    var n = pts.length;
    var d = 'M ' + pts[0][0].toFixed(1) + ',' + pts[0][1].toFixed(1) + ' ';
    for (var i = 0; i < n; i++) {
      var p0 = pts[(i - 1 + n) % n], p1 = pts[i], p2 = pts[(i + 1) % n], p3 = pts[(i + 2) % n];
      var c1x = p1[0] + (p2[0] - p0[0]) / 6, c1y = p1[1] + (p2[1] - p0[1]) / 6;
      var c2x = p2[0] - (p3[0] - p1[0]) / 6, c2y = p2[1] - (p3[1] - p1[1]) / 6;
      d += 'C ' + c1x.toFixed(1) + ',' + c1y.toFixed(1) + ' ' + c2x.toFixed(1) + ',' + c2y.toFixed(1) + ' ' + p2[0].toFixed(1) + ',' + p2[1].toFixed(1) + ' ';
    }
    return d + 'Z';
  }
  var ORGANIC_PATHS = {
    circo: [[0.50, 0.04], [0.70, 0.05], [0.83, 0.18], [0.785, 0.35], [0.93, 0.48], [0.83, 0.63], [0.875, 0.80], [0.66, 0.93], [0.47, 0.88], [0.30, 0.95], [0.175, 0.79], [0.255, 0.62], [0.08, 0.49], [0.205, 0.35], [0.16, 0.17], [0.34, 0.11]],
    agata: [[0.50, 0.015], [0.80, 0.03], [0.95, 0.16], [0.985, 0.42], [0.985, 0.58], [0.95, 0.84], [0.80, 0.97], [0.50, 0.985], [0.20, 0.97], [0.05, 0.84], [0.015, 0.58], [0.015, 0.42], [0.05, 0.16], [0.20, 0.03]]
  };

  function rugSVG(o, X, Y, L) {
    var x = +X(o.x), y = +Y(o.y), w = +L(o.w), h = +L(o.h), shp = o.shape || 'rect';
    if (shp === 'round' || shp === 'oval') {
      return '<ellipse cx="' + (x + w / 2).toFixed(1) + '" cy="' + (y + h / 2).toFixed(1) + '" rx="' + (w / 2).toFixed(1) + '" ry="' + (h / 2).toFixed(1) + '" fill="' + C.rug + '" stroke="' + C.rugline + '" stroke-width="1.6"/>';
    }
    /* ── LE TAPIS DECOUPE EN U (G17b) ───────────────────────────────────────
       Un contour de WC est un rectangle dont le bord ARRIERE porte une
       echancrure, celle qui laisse passer le pied de la cuvette. L'echancrure
       est donnee en CENTIMETRES par la scene (`o.nw`, `o.nd`) et passe ici par
       la meme fonction d'echelle que le reste : elle est donc a l'echelle du
       produit, comme ses deux cotes, et non dessinee « a peu pres ».
       Les angles rentrants ne sont PAS arrondis : sur un tapis de 50 cm rendu
       dans une boite de 400 unites, un rayon les fermerait visuellement et le
       U se lirait comme une simple encoche. */
    if (shp === 'u') {
      var nw = +L(o.nw), nd = +L(o.nd);
      var n0 = x + (w - nw) / 2, n1 = n0 + nw;
      var du = 'M' + x.toFixed(1) + ' ' + y.toFixed(1)
        + 'H' + n0.toFixed(1) + 'V' + (y + nd).toFixed(1)
        + 'H' + n1.toFixed(1) + 'V' + y.toFixed(1)
        + 'H' + (x + w).toFixed(1) + 'V' + (y + h).toFixed(1)
        + 'H' + x.toFixed(1) + 'Z';
      return '<path d="' + du + '" fill="' + C.rug + '" stroke="' + C.rugline + '" stroke-width="1.6"/>';
    }
    if (shp === 'organic') {
      var NP = ORGANIC_PATHS[ORGANIC] || ORGANIC_PATHS.circo;
      var cx = x + w / 2, cy = y + h / 2;
      var pts = NP.map(function (p) { return [x + p[0] * w, y + p[1] * h]; });
      var inn = pts.map(function (p) { return [cx + (p[0] - cx) * 0.82, cy + (p[1] - cy) * 0.82]; });
      return '<path d="' + smoothClosed(pts) + '" fill="' + C.rug + '" stroke="' + C.rugline + '" stroke-width="1.6"/>'
           + '<path d="' + smoothClosed(inn) + '" fill="none" stroke="' + C.rugline + '" stroke-width="1" opacity=".8"/>';
    }
    var r = Math.min(w, h) * 0.05;
    return '<rect x="' + x.toFixed(1) + '" y="' + y.toFixed(1) + '" width="' + w.toFixed(1) + '" height="' + h.toFixed(1) + '" rx="' + r.toFixed(1) + '" fill="' + C.rug + '" stroke="' + C.rugline + '" stroke-width="1.6"/>';
  }

  function furnSVG(o, X, Y, L) {
    var x = +X(o.x), y = +Y(o.y), w = +L(o.w), h = +L(o.h);
    var stroke = C.furn;
    var base = 'fill="' + C.furnFill + '" stroke="' + stroke + '" stroke-width="1.6"';
    var r = Math.min(w, h) * 0.13;
    if (o.kind === 'sofa' && o.corner) {
      var cw = +L(o.chaiseW), bd = +L(o.backD), ins = +L(15), rr = +L(10);
      var d = 'M' + (x + rr) + ' ' + y + ' L' + (x + w - rr) + ' ' + y + ' Q' + (x + w) + ' ' + y + ' ' + (x + w) + ' ' + (y + rr) + ' L' + (x + w) + ' ' + (y + h - rr) + ' Q' + (x + w) + ' ' + (y + h) + ' ' + (x + w - rr) + ' ' + (y + h) + ' L' + (x + w - cw + rr) + ' ' + (y + h) + ' Q' + (x + w - cw) + ' ' + (y + h) + ' ' + (x + w - cw) + ' ' + (y + h - rr) + ' L' + (x + w - cw) + ' ' + (y + bd + rr) + ' Q' + (x + w - cw) + ' ' + (y + bd) + ' ' + (x + w - cw - rr) + ' ' + (y + bd) + ' L' + (x + rr) + ' ' + (y + bd) + ' Q' + x + ' ' + (y + bd) + ' ' + x + ' ' + (y + bd - rr) + ' L' + x + ' ' + (y + rr) + ' Q' + x + ' ' + y + ' ' + (x + rr) + ' ' + y + ' Z';
      var s = '<path d="' + d + '" ' + base + ' stroke-linejoin="round"/>';
      s += '<path d="M' + (x + ins) + ' ' + (y + bd) + ' L' + (x + ins) + ' ' + (y + ins) + ' L' + (x + w - ins) + ' ' + (y + ins) + ' L' + (x + w - ins) + ' ' + (y + h - ins) + ' L' + (x + w - cw + ins) + ' ' + (y + h - ins) + '" fill="none" stroke="' + stroke + '" stroke-width="1.1"/>';
      s += '<line x1="' + (x + w - cw) + '" y1="' + (y + bd) + '" x2="' + (x + w - cw) + '" y2="' + (y + h - ins) + '" stroke="' + stroke + '" stroke-width="1"/>';
      var mR = (x + w - cw) - (x + ins);
      for (var i = 1; i < 3; i++) {
        var cxx = x + ins + mR * i / 3;
        s += '<line x1="' + cxx + '" y1="' + (y + ins) + '" x2="' + cxx + '" y2="' + (y + bd) + '" stroke="' + stroke + '" stroke-width="0.9"/>';
      }
      return s;
    }
    if (o.kind === 'sofa') {
      var n = o.seats || 3, arm = +L(16), back = +L(19);
      var t = '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" rx="' + r + '" ' + base + '/>';
      t += '<line x1="' + (x + arm) + '" y1="' + (y + back) + '" x2="' + (x + w - arm) + '" y2="' + (y + back) + '" stroke="' + stroke + '" stroke-width="1.2"/>';
      t += '<line x1="' + (x + arm) + '" y1="' + (y + back - +L(3)) + '" x2="' + (x + arm) + '" y2="' + (y + h - +L(3)) + '" stroke="' + stroke + '" stroke-width="1.2"/>';
      t += '<line x1="' + (x + w - arm) + '" y1="' + (y + back - +L(3)) + '" x2="' + (x + w - arm) + '" y2="' + (y + h - +L(3)) + '" stroke="' + stroke + '" stroke-width="1.2"/>';
      for (var j = 1; j < n; j++) {
        var cx2 = x + arm + (w - 2 * arm) * j / n;
        t += '<line x1="' + cx2 + '" y1="' + (y + back) + '" x2="' + cx2 + '" y2="' + (y + h - +L(3)) + '" stroke="' + stroke + '" stroke-width="1"/>';
      }
      return t;
    }
    if (o.kind === 'table') {
      if (o.round) {
        return '<ellipse cx="' + (x + w / 2) + '" cy="' + (y + h / 2) + '" rx="' + (w / 2) + '" ry="' + (h / 2) + '" ' + base + '/>'
             + '<ellipse cx="' + (x + w / 2) + '" cy="' + (y + h / 2) + '" rx="' + (w / 2 - +L(7)) + '" ry="' + (h / 2 - +L(7)) + '" fill="none" stroke="' + stroke + '" stroke-width="0.9" opacity=".4"/>';
      }
      var rt = +L(8);
      return '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" rx="' + rt + '" ' + base + '/>'
           + '<rect x="' + (x + +L(7)) + '" y="' + (y + +L(7)) + '" width="' + (w - 2 * L(7)) + '" height="' + (h - 2 * L(7)) + '" rx="' + (rt * 0.6) + '" fill="none" stroke="' + stroke + '" stroke-width="0.9" opacity=".4"/>';
    }
    if (o.kind === 'chair') {
      var face = o.face || 'up', bar = +L(9), rr2 = +L(6);
      var sx = x, sy = y, sw = w, sh = h, bx = x, by = y, bw = w, bh = bar;
      if (face === 'up') { bh = bar; sy = y + bar; sh = h - bar; }
      else if (face === 'down') { by = y + h - bar; bh = bar; sh = h - bar; }
      else if (face === 'left') { bw = bar; bh = h; sx = x + bar; sw = w - bar; }
      else { bx = x + w - bar; bw = bar; bh = h; sw = w - bar; }
      return '<rect x="' + sx + '" y="' + sy + '" width="' + sw + '" height="' + sh + '" rx="' + rr2 + '" ' + base + ' stroke-width="1.3"/>'
           + '<rect x="' + bx + '" y="' + by + '" width="' + bw + '" height="' + bh + '" rx="' + (+L(3)) + '" fill="' + C.soft + '" stroke="' + stroke + '" stroke-width="1.2"/>';
    }
    if (o.kind === 'bed') {
      var hb = +L(11), rO = +L(9), mY = y + hb, mH = h - hb, single = o.single;
      var u = '<rect x="' + (x - +L(2)) + '" y="' + y + '" width="' + (w + +L(4)) + '" height="' + hb + '" rx="' + (+L(5)) + '" fill="' + C.soft + '" stroke="' + stroke + '" stroke-width="1.4"/>';
      u += '<rect x="' + x + '" y="' + mY + '" width="' + w + '" height="' + mH + '" rx="' + rO + '" ' + base + '/>';
      var ph = +L(27), py = mY + +L(8), pf = 'fill="' + C.furnFill + '" stroke="' + stroke + '" stroke-width="1"';
      if (single) {
        var pw1 = w - 2 * +L(10);
        u += '<rect x="' + (x + +L(10)) + '" y="' + py + '" width="' + pw1 + '" height="' + ph + '" rx="' + (+L(8)) + '" ' + pf + '/>';
      } else {
        var pw = (w - 3 * +L(8)) / 2;
        u += '<rect x="' + (x + +L(8)) + '" y="' + py + '" width="' + pw + '" height="' + ph + '" rx="' + (+L(7)) + '" ' + pf + '/>';
        u += '<rect x="' + (x + w - +L(8) - pw) + '" y="' + py + '" width="' + pw + '" height="' + ph + '" rx="' + (+L(7)) + '" ' + pf + '/>';
      }
      var dY = py + ph + +L(11);
      u += '<path d="M' + x + ' ' + dY + ' Q ' + (x + w / 2) + ' ' + (dY - +L(6)) + ' ' + (x + w) + ' ' + dY + '" fill="none" stroke="' + stroke + '" stroke-width="1.1"/>';
      if (!single) u += '<line x1="' + (x + w / 2) + '" y1="' + (dY + +L(8)) + '" x2="' + (x + w / 2) + '" y2="' + (mY + mH - +L(9)) + '" stroke="' + stroke + '" stroke-width="0.8" opacity=".3"/>';
      return u;
    }
    if (o.kind === 'counter') {
      /* `contour` (G6.5, fix round 1) : le meuble se dessine en Papier au lieu
         du fond plein, pour rester dans la famille visuelle « Vos meubles » de
         la legende. En bain, un fond plein proche du creme du tapis faisait
         lire le meuble vasque comme un troisieme tapis. Le plan de travail de
         la cuisine garde son fond plein : il n'a pas de tapis a cote de lui. */
      var fondC = o.contour ? C.furnFill : C.soft;
      var v = '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" rx="' + (+L(5)) + '" fill="' + fondC + '" stroke="' + stroke + '" stroke-width="1.5"/>';
      var sw2 = +L(52), sh2 = +L(32), sx2 = x + w * 0.5 - sw2 / 2, sy2 = y + h * 0.5 - sh2 / 2;
      v += '<rect x="' + sx2 + '" y="' + sy2 + '" width="' + sw2 + '" height="' + sh2 + '" rx="' + (+L(5)) + '" fill="' + (o.contour ? 'none' : C.furnFill) + '" stroke="' + stroke + '" stroke-width="1"/>';
      v += '<circle cx="' + (x + w * 0.5) + '" cy="' + (y + h * 0.5) + '" r="' + (+L(4)) + '" fill="none" stroke="' + stroke + '" stroke-width="1"/>';
      return v;
    }
    /* ── LES WC, VUS DE DESSUS (G17b) ─────────────────────────────────────
       Deux formes et pas une de plus : un reservoir contre le mur, en haut, et
       une cuvette ovale devant lui. C'est ce qu'on voit d'un WC quand on
       regarde le sol, et c'est ce qui rend l'echancrure du tapis lisible sans
       une legende. Meme trait que les autres meubles, meme fond Papier que le
       meuble vasque (`contour`) : ce n'est pas un troisieme tapis.
       `o.res` est la profondeur du reservoir, en centimetres, mise a l'echelle
       comme le reste : le dessin suit la scene, il ne fixe rien. */
    if (o.kind === 'wc') {
      var res = +L(o.res), cuve = +L(o.cuve), pied = +L(o.pied);
      var cx0 = x + w / 2;
      /* LE RESERVOIR, contre le mur, en haut. */
      var t2 = '<rect x="' + x.toFixed(1) + '" y="' + y.toFixed(1) + '" width="' + w.toFixed(1) + '" height="' + res.toFixed(1) + '" rx="' + (+L(3)).toFixed(1) + '" fill="' + C.furnFill + '" stroke="' + stroke + '" stroke-width="1.4"/>';
      /* LA CUVETTE, une ellipse posee sous lui, un peu moins large que lui : de
         dessus, c'est cette forme-la qu'on reconnait sans legende. Elle
         s'arrete AU BORD du tapis, elle ne passe pas dessus : ce qui entre dans
         l'echancrure est le pied, dessine juste apres. */
      var cw = w * 0.9, cX = cx0 - cw / 2, cY = y + res;
      t2 += '<ellipse cx="' + cx0.toFixed(1) + '" cy="' + (cY + cuve / 2).toFixed(1) + '" rx="' + (cw / 2).toFixed(1) + '" ry="' + (cuve / 2).toFixed(1) + '" fill="' + C.furnFill + '" stroke="' + stroke + '" stroke-width="1.5"/>';
      t2 += '<ellipse cx="' + cx0.toFixed(1) + '" cy="' + (cY + cuve * 0.52).toFixed(1) + '" rx="' + (cw * 0.31).toFixed(1) + '" ry="' + (cuve * 0.30).toFixed(1) + '" fill="none" stroke="' + stroke + '" stroke-width="1" opacity=".55"/>';
      /* LE PIED, DANS L'ECHANCRURE. C'est lui que le U entoure, et c'est la
         seule partie du WC qui touche le sol : le tapis se lit autour de lui. */
      var pY = cY + cuve - +L(3), pH = (y + h) - pY;
      if (pH > 0) {
        t2 += '<rect x="' + (cx0 - pied / 2).toFixed(1) + '" y="' + pY.toFixed(1) + '" width="' + pied.toFixed(1) + '" height="' + pH.toFixed(1) + '" rx="' + (+L(2)).toFixed(1) + '" fill="' + C.furnFill + '" stroke="' + stroke + '" stroke-width="1.3"/>';
      }
      return t2;
    }
    /* ── LE LAVABO SUR COLONNE, VU DE DESSUS (G18a) ───────────────────────
       Retour de Raph du 08/09 a 00h47 : « le U a deux positions : autour d'un
       lavabo sur pied (il epouse la colonne et cache la tuyauterie) ou autour
       des WC ». La vue lavabo d'un kit decoupe en U ne peut donc pas montrer
       un meuble vasque (`counter`), qui est un caisson pose au sol : un
       contour en U n'aurait rien a entourer devant lui.

       DEUX FORMES, LES MEMES QUE LE WC, ET POUR LA MEME RAISON : la vasque,
       contre le mur, et la colonne qui descend dans l'echancrure. C'est ce
       qu'on voit d'un lavabo sur pied quand on regarde le sol, et c'est ce qui
       rend l'echancrure lisible sans legende. Meme trait et meme fond Papier
       que les autres meubles de la scene : ce n'est pas un troisieme tapis.

       `o.vasque` est la profondeur de la vasque en centimetres, mise a
       l'echelle comme le reste : le dessin suit la scene, il ne fixe rien. */
    if (o.kind === 'lavabo') {
      var vas = +L(o.vasque), col = +L(o.pied);
      var cx1 = x + w / 2;
      /* LA VASQUE : une boite tres arrondie contre le mur, et la cuve a
         l'interieur. Deux traits, comme le meuble vasque en avait deux. */
      var t3 = '<rect x="' + x.toFixed(1) + '" y="' + y.toFixed(1) + '" width="' + w.toFixed(1) + '" height="' + vas.toFixed(1) + '" rx="' + (+L(9)).toFixed(1) + '" fill="' + C.furnFill + '" stroke="' + stroke + '" stroke-width="1.5"/>';
      t3 += '<ellipse cx="' + cx1.toFixed(1) + '" cy="' + (y + vas * 0.54).toFixed(1) + '" rx="' + (w * 0.33).toFixed(1) + '" ry="' + (vas * 0.30).toFixed(1) + '" fill="none" stroke="' + stroke + '" stroke-width="1"/>';
      /* LA BONDE, au centre de la cuve : le seul detail qui dit « lavabo » et
         non « caisson », et il tient en un cercle. */
      t3 += '<circle cx="' + cx1.toFixed(1) + '" cy="' + (y + vas * 0.54).toFixed(1) + '" r="' + (+L(3)).toFixed(1) + '" fill="none" stroke="' + stroke + '" stroke-width="1"/>';
      /* LA COLONNE, DANS L'ECHANCRURE. C'est elle que le U epouse, et c'est la
         seule partie du lavabo qui touche le sol : le tapis se lit autour
         d'elle, et la tuyauterie qu'elle cache est justement ce que le contour
         vient border. */
      var cY2 = y + vas - +L(3), cH2 = (y + h) - cY2;
      if (cH2 > 0) {
        t3 += '<rect x="' + (cx1 - col / 2).toFixed(1) + '" y="' + cY2.toFixed(1) + '" width="' + col.toFixed(1) + '" height="' + cH2.toFixed(1) + '" rx="' + (+L(2)).toFixed(1) + '" fill="' + C.furnFill + '" stroke="' + stroke + '" stroke-width="1.3"/>';
      }
      return t3;
    }
    if (o.kind === 'door') {
      var z = '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" rx="' + (+L(2)) + '" fill="' + C.soft + '" stroke="' + stroke + '" stroke-width="1.2"/>';
      var lh = Math.min(w * 0.92, +L(64));
      z += '<line x1="' + (x + w) + '" y1="' + (y + h) + '" x2="' + (x + w - lh) + '" y2="' + (y + h) + '" stroke="' + stroke + '" stroke-width="1.4"/>';
      z += '<path d="M' + (x + w - lh) + ' ' + (y + h) + ' A ' + lh + ' ' + lh + ' 0 0 0 ' + (x + w) + ' ' + (y + h + lh) + '" fill="none" stroke="' + stroke + '" stroke-width="0.9" stroke-dasharray="3 3" opacity=".45"/>';
      return z;
    }
    if (o.kind === 'wall') return '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" fill="' + C.soft + '"/>';
    return '';
  }

  /* Cotes et debords : LE TRAIT reste dans le SVG, L'ETIQUETTE en sort. */
  function dimSVG(o, X, Y) {
    var x1 = +X(o.x1), y1 = +Y(o.y1), x2 = +X(o.x2), y2 = +Y(o.y2);
    var vert = Math.abs(o.y2 - o.y1) > Math.abs(o.x2 - o.x1), tk = 4;
    var s = '<line x1="' + x1 + '" y1="' + y1 + '" x2="' + x2 + '" y2="' + y2 + '" stroke="' + C.dim + '" stroke-width="1"/>';
    if (vert) {
      s += '<line x1="' + (x1 - tk) + '" y1="' + y1 + '" x2="' + (x1 + tk) + '" y2="' + y1 + '" stroke="' + C.dim + '" stroke-width="1"/>';
      s += '<line x1="' + (x2 - tk) + '" y1="' + y2 + '" x2="' + (x2 + tk) + '" y2="' + y2 + '" stroke="' + C.dim + '" stroke-width="1"/>';
    } else {
      s += '<line x1="' + x1 + '" y1="' + (y1 - tk) + '" x2="' + x1 + '" y2="' + (y1 + tk) + '" stroke="' + C.dim + '" stroke-width="1"/>';
      s += '<line x1="' + x2 + '" y1="' + (y2 - tk) + '" x2="' + x2 + '" y2="' + (y2 + tk) + '" stroke="' + C.dim + '" stroke-width="1"/>';
    }
    return s;
  }
  function debSVG(o, X, Y) {
    var x1 = +X(o.x1), y1 = +Y(o.y1), x2 = +X(o.x2), y2 = +Y(o.y2);
    return '<line x1="' + x1 + '" y1="' + y1 + '" x2="' + x2 + '" y2="' + y2 + '" stroke="' + C.gold + '" stroke-width="1.5" marker-start="url(#cmt-ah)" marker-end="url(#cmt-ah)"/>';
  }

  /* `render()`, correction 1. viewBox FIXE 400 x 300, exactement le rapport
     4/3 de la boite : un pourcentage de l'une est un pourcentage de l'autre,
     ce qui rend exacte la pose des cotes en HTML. Marge de 30 unites tout
     autour pour ces etiquettes, qui vivent hors du SVG et ne sont donc pas
     mesurables ici. Aucun `width` ni `height` en pixels. */
  var VBW = 400, VBH = 300, VBM = 30;
  function render(prims) {
    /* `rugSVG`, `furnSVG`, `dimSVG` et `debSVG` lisent `C` et ne sont appelees
       que d'ici : une demande ici les sert toutes. */
    palette();
    var bb = bboxOf(prims);
    var wCm = Math.max(1, bb.x1 - bb.x0), hCm = Math.max(1, bb.y1 - bb.y0);
    var S = Math.min((VBW - 2 * VBM) / wCm, (VBH - 2 * VBM) / hCm);
    var ox = (VBW - wCm * S) / 2 - bb.x0 * S;
    var oy = (VBH - hCm * S) / 2 - bb.y0 * S;
    var X = function (x) { return (x * S + ox).toFixed(1); };
    var Y = function (y) { return (y * S + oy).toFixed(1); };
    var L = function (v) { return (v * S).toFixed(1); };

    var etiquettes = [];
    var defs = '<defs><marker id="cmt-ah" markerWidth="9" markerHeight="9" refX="4.5" refY="4.5" orient="auto"><path d="M8,4.5 L2,1.6 L3.6,4.5 L2,7.4 Z" fill="' + C.gold + '"/></marker></defs>';
    var b = '';
    prims.forEach(function (o) { if (o.t === 'rug') b += rugSVG(o, X, Y, L); });
    prims.forEach(function (o) { if (o.t === 'furn') b += furnSVG(o, X, Y, L); });
    prims.forEach(function (o) {
      if (o.t !== 'dim' && o.t !== 'deb') return;
      b += (o.t === 'dim' ? dimSVG : debSVG)(o, X, Y);
      if (!o.label) return;
      etiquettes.push({
        x: ((o.x1 + o.x2) / 2) * S + ox,
        y: ((o.y1 + o.y2) / 2) * S + oy,
        t: o.label,
        or: o.t === 'deb'
      });
    });
    var svg = '<svg class="cmt-svg" viewBox="0 0 ' + VBW + ' ' + VBH + '" preserveAspectRatio="xMidYMid meet" aria-hidden="true" focusable="false">' + defs + b + '</svg>';
    return { svg: svg, etiquettes: etiquettes };
  }

  /* ══════════════════ SCENES, recopiees l.109 a 198 ══════════════════════ */
  function sceneSalon(f, sofaType) {
    var d = dimsOf(f), Lg = d.l, W = d.w;
    var isAngle = sofaType === 'angle';
    var sw, sd, seats, chaiseW = 92, backD = 86;
    if (sofaType === '2') { sw = 150; sd = 84; seats = 2; }
    else if (isAngle) { sw = 250; sd = 158; seats = 3; }
    else { sw = 210; sd = 88; seats = 3; }
    var sx = Lg / 2 - sw / 2, slackL = Lg - sw, slackW = W - sd, tw = 110, td = 44, GAP = 45;
    var placement, verdict;
    if (isAngle) {
      if (slackL >= 36 && slackW >= 36) { placement = 'tout'; verdict = T.salonAngle; }
      else if (Lg >= sw - 8) { placement = 'avant'; verdict = T.salonAvant; }
      else { placement = 'petit'; verdict = T.salonPetit; }
    } else {
      var needTout = sd + 40 + td;
      if (slackL >= 36 && W >= needTout) { placement = 'tout'; verdict = T.salonTout; }
      else if (Lg >= sw - 8) { placement = 'avant'; verdict = T.salonAvant; }
      else { placement = 'petit'; verdict = T.salonPetit; }
    }
    var sy, ty, tableX = Lg / 2 - tw / 2, tableY;
    if (isAngle) {
      if (placement === 'tout') sy = (W - sd) / 2;
      else if (placement === 'avant') sy = -(sd - 42);
      else sy = -(sd - 14);
      tableX = sx + (sw - chaiseW) / 2 - tw / 2;
      tableY = Math.max(8, Math.min(W - td - 8, sy + backD + ((sd - backD) - td) / 2));
    } else {
      if (placement === 'tout') {
        var topM = Math.max(8, Math.min(40, (W - (sd + GAP + td)) * 0.32));
        var gap0 = GAP, botM = W - sd - td - topM - gap0;
        if (botM < 8) gap0 = Math.max(20, W - sd - td - topM - 8);
        sy = topM; ty = sy + sd + gap0;
      } else if (placement === 'avant') {
        sy = -(sd - 30);
        var gap1 = Math.max(30, Math.min(48, (W - 30 - td) * 0.42));
        ty = 30 + gap1;
      } else {
        sy = -(sd - 30);
        ty = Math.min(W - td - 8, Math.max(sy + sd + 12, W * 0.5));
      }
      tableY = ty;
    }
    var r = rug(f); r.w = Lg; r.h = W;
    var sofaPrim = isAngle
      ? { t: 'furn', kind: 'sofa', corner: true, chaiseW: chaiseW, backD: backD, x: sx, y: sy, w: sw, h: sd }
      : { t: 'furn', kind: 'sofa', seats: seats, x: sx, y: sy, w: sw, h: sd };
    var P = [r, sofaPrim];
    var tblIn = (tableX >= -4 && tableX + tw <= Lg + 4 && tableY >= -4 && tableY + td <= W + 4);
    var showTbl = tblIn && (isAngle || ((W - (sy + sd)) >= td + 10));
    if (showTbl) P.push({ t: 'furn', kind: 'table', round: SHAPE === 'round', x: tableX, y: tableY, w: tw, h: td });
    P.push({ t: 'dim', x1: 0, y1: W + 22, x2: Lg, y2: W + 22, label: Lg + ' cm' },
           { t: 'dim', x1: -22, y1: 0, x2: -22, y2: W, label: isRound(f) ? 'Ø' + f.dia : W + ' cm' });
    var serre = false;
    if (placement === 'petit') serre = true;
    else {
      var gap2 = Lg - (sx + sw);
      if (gap2 > 6) {
        var yy = Math.max(20, Math.min(W - 20, placement === 'avant' ? Math.max(16, sy + sd * 0.85) : sy + sd * 0.5));
        P.push({ t: 'deb', x1: sx + sw, y1: yy, x2: Lg, y2: yy, label: Math.round(gap2) + ' cm' });
      }
    }
    return { prims: P, serre: serre, verdict: verdict, avert: '' };
  }

  function sceneChambre(f, bw) {
    var d = dimsOf(f), Lg = d.l, W = d.w;
    var b = bw || 160, bl = 200, bx = Lg / 2 - b / 2, by = -(bl * 0.30), single = (b <= 100);
    var r = rug(f); r.w = Lg; r.h = W;
    var P = [r,
      { t: 'furn', kind: 'bed', single: single, x: bx, y: by, w: b, h: bl },
      { t: 'dim', x1: 0, y1: W + 22, x2: Lg, y2: W + 22, label: Lg + ' cm' },
      { t: 'dim', x1: -22, y1: 0, x2: -22, y2: W, label: isRound(f) ? 'Ø' + f.dia : W + ' cm' }];
    var side = bx, foot = W - (by + bl), verdict = '', avert = '', serre = false;
    if (side > 7) P.push({ t: 'deb', x1: 0, y1: W * 0.72, x2: bx, y2: W * 0.72, label: Math.round(side) + ' cm' });
    if (foot > 7) P.push({ t: 'deb', x1: Lg * 0.5, y1: by + bl, x2: Lg * 0.5, y2: W, label: Math.round(foot) + ' cm' });
    if (side < 7 || foot < 2) { avert = T.chambreAvert; verdict = T.chambreJuste; serre = true; }
    else verdict = tpl(T.chambreOk, { '[c]': String(Math.round(side)), '[p]': String(Math.round(Math.max(0, foot))) });
    return { prims: P, serre: serre, verdict: verdict, avert: avert };
  }

  function sceneSAM(f, seats) {
    var d = dimsOf(f), Lg = d.l, W = d.w;
    var roundT = SHAPE === 'round';
    var tw, td, per;
    if (seats === 4) { tw = roundT ? 115 : 120; td = roundT ? 115 : 80; per = 2; }
    else if (seats === 6) { tw = roundT ? 135 : 180; td = roundT ? 135 : 90; per = 3; }
    else { tw = roundT ? 155 : 220; td = roundT ? 155 : 100; per = 4; }
    var tx = Lg / 2 - tw / 2, ty = W / 2 - td / 2;
    var r = rug(f); r.w = Lg; r.h = W;
    var P = [r, { t: 'furn', kind: 'table', round: roundT, x: tx, y: ty, w: tw, h: td }];
    var cw = 46, cd = 48, g = 14, clr;
    if (roundT) {
      var R = tw / 2, cx = Lg / 2, cy = W / 2, rr = R + g + cd * 0.42, N = seats;
      for (var i = 0; i < N; i++) {
        var a = (i / N) * Math.PI * 2 - Math.PI / 2;
        var px = cx + Math.cos(a) * rr, py = cy + Math.sin(a) * rr;
        var face = Math.abs(Math.cos(a)) > Math.abs(Math.sin(a)) ? (Math.cos(a) > 0 ? 'right' : 'left') : (Math.sin(a) > 0 ? 'down' : 'up');
        P.push({ t: 'furn', kind: 'chair', face: face, x: px - cw / 2, y: py - cd / 2, w: cw, h: cd });
      }
      clr = W / 2 - (R + g + cd);
    } else {
      var pullT = Math.max(0, Math.min(g, ty - cd - 4));
      var pullB = Math.max(0, Math.min(g, (W - (ty + td)) - cd - 4));
      for (var k = 0; k < per; k++) {
        var cx3 = tx + (tw - cw) * (per === 1 ? 0.5 : k / (per - 1));
        P.push({ t: 'furn', kind: 'chair', face: 'up', x: cx3, y: ty - cd - pullT, w: cw, h: cd });
        P.push({ t: 'furn', kind: 'chair', face: 'down', x: cx3, y: ty + td + pullB, w: cw, h: cd });
      }
      clr = Math.min(ty - cd, (W - (ty + td)) - cd);
    }
    P.push({ t: 'dim', x1: 0, y1: W + 22, x2: Lg, y2: W + 22, label: Lg + ' cm' },
           { t: 'dim', x1: -22, y1: 0, x2: -22, y2: W, label: isRound(f) ? 'Ø' + f.dia : W + ' cm' });
    var verdict, avert = '', serre = false;
    if (clr < -4) { avert = T.samAvert; verdict = T.samJuste; serre = true; }
    else {
      P.push({ t: 'deb', x1: tx + tw, y1: W / 2, x2: Lg, y2: W / 2, label: '+' + Math.round((Lg - tw) / 2) + ' cm' });
      verdict = T.samOk;
    }
    return { prims: P, serre: serre, verdict: verdict, avert: avert };
  }

  function sceneEntree(f) {
    var d = dimsOf(f);
    return (d.l / d.w >= 2.6) ? sceneCorridor(f) : sceneEntreeMat(f);
  }

  /* MARGE : 5 cm, la valeur ecrite par la marque, tranchee le 05/09 (§ 6.2
     point 10). `m = 15` reste l'ecartement de DESSIN, en unites de scene :
     sans lui la cote et son etiquette se chevaucheraient sur un couloir de
     60 cm. `mAff = 5` est le chiffre ANNONCE. Ne pas les confondre. */
  function sceneCorridor(f) {
    var d = dimsOf(f), Wd = d.w, Lg = d.l, m = 15, mAff = 5;
    var r = rug(f); r.x = 0; r.y = 0; r.w = Wd; r.h = Lg;
    var P = [
      { t: 'furn', kind: 'wall', x: -m - 8, y: -12, w: 8, h: Lg + 24 },
      { t: 'furn', kind: 'wall', x: Wd + m, y: -12, w: 8, h: Lg + 24 },
      r,
      { t: 'dim', x1: 0, y1: Lg + 22, x2: Wd, y2: Lg + 22, label: Wd + ' cm' },
      { t: 'dim', x1: Wd + m + 38, y1: 0, x2: Wd + m + 38, y2: Lg, label: Lg + ' cm' },
      { t: 'deb', x1: -m, y1: Lg * 0.5, x2: 0, y2: Lg * 0.5, label: String(mAff) },
      { t: 'deb', x1: Wd, y1: Lg * 0.5, x2: Wd + m, y2: Lg * 0.5, label: String(mAff) }
    ];
    return { prims: P, serre: false, verdict: tpl(T.entreeCouloir, { '[m]': String(mAff) }), avert: '' };
  }

  function sceneEntreeMat(f) {
    var d = dimsOf(f), Lg = d.l, W = d.w;
    var wt = 8, gap = 16, ext = 40, DOOR = 83;
    var mat = (W <= 45 && Lg <= 70);
    var r = rug(f); r.x = 0; r.y = 0;
    var span;
    if (mat) { r.w = Lg; r.h = W; span = Lg; }
    else { r.w = W; r.h = Lg; span = W; }
    var dl = span / 2 - DOOR / 2;
    var wallL = Math.min(-ext, dl - 4), wallR = Math.max(span + ext, dl + DOOR + 4);
    var P = [r];
    if (dl > wallL) P.push({ t: 'furn', kind: 'wall', x: wallL, y: -(wt + gap), w: dl - wallL, h: wt });
    if (wallR > dl + DOOR) P.push({ t: 'furn', kind: 'wall', x: dl + DOOR, y: -(wt + gap), w: wallR - (dl + DOOR), h: wt });
    P.push({ t: 'furn', kind: 'door', x: dl, y: -(wt + gap), w: DOOR, h: wt });
    P.push({ t: 'dim', x1: 0, y1: r.h + 22, x2: r.w, y2: r.h + 22, label: r.w + ' cm' },
           { t: 'dim', x1: -22, y1: 0, x2: -22, y2: r.h, label: r.h + ' cm' });
    return { prims: P, serre: false, verdict: T.entreePorte, avert: '' };
  }

  function sceneCuisine(f) {
    var d = dimsOf(f), Lg = d.l, W = d.w;
    var cH = 58, gap = 12, cW = Math.max(Lg + 70, 240), cx = Lg / 2 - cW / 2;
    var r = rug(f); r.x = 0; r.y = 0; r.w = Lg; r.h = W;
    var P = [
      { t: 'furn', kind: 'counter', x: cx, y: -(cH + gap), w: cW, h: cH },
      r,
      { t: 'dim', x1: 0, y1: W + 22, x2: Lg, y2: W + 22, label: Lg + ' cm' },
      { t: 'dim', x1: -22, y1: 0, x2: -22, y2: W, label: W + ' cm' }
    ];
    return { prims: P, serre: false, verdict: T.cuisine, avert: '' };
  }

  function sceneLounge(f) {
    var d = dimsOf(f), Lg = d.l, W = d.w;
    var gap = Math.max(24, Lg * 0.14);
    var aw = Math.min(94, Math.max(58, (Lg - gap - 8) / 2)), ad = 88;
    var totalW = aw * 2 + gap, x0 = Lg / 2 - totalW / 2, needTout = ad + 42 + 44;
    var sy, verdict;
    if (W >= needTout) { sy = Math.max(8, Math.min(36, (W - needTout) * 0.5)); verdict = T.loungeTout; }
    else { sy = -(ad - 28); verdict = T.loungeAvant; }
    var r = rug(f); r.w = Lg; r.h = W;
    var P = [r,
      { t: 'furn', kind: 'sofa', seats: 1, x: x0, y: sy, w: aw, h: ad },
      { t: 'furn', kind: 'sofa', seats: 1, x: x0 + aw + gap, y: sy, w: aw, h: ad }];
    var td = 44, tw = Math.min(104, gap + 30), tableTop = sy + ad + 16;
    if (W - tableTop >= td + 8) P.push({ t: 'furn', kind: 'table', round: SHAPE === 'round', x: Lg / 2 - tw / 2, y: Math.min(tableTop, W - td - 8), w: tw, h: td });
    P.push({ t: 'dim', x1: 0, y1: W + 22, x2: Lg, y2: W + 22, label: Lg + ' cm' },
           { t: 'dim', x1: -22, y1: 0, x2: -22, y2: W, label: isRound(f) ? 'Ø' + f.dia : W + ' cm' });
    return { prims: P, serre: false, verdict: verdict, avert: '' };
  }

  /* ── LA SALLE DE BAIN, G6.5 ────────────────────────────────────────────
     Un kit de bain n'a qu'un format (releve Admin du 06/09 : les 106 fiches
     ont exactement une valeur de taille, `50 x 80 + 40 x 50 cm` sur 92 et
     `60 x 100 + 50 x 60 cm` sur 14). Il n'y a donc rien a comparer, et tout a
     MONTRER : ce que ce guide apporte ici, c'est la reponse a la seule
     question que pose un kit, « lequel des deux va ou ».

     La scene est une vue de dessus : la baignoire ou la douche a gauche, le
     meuble vasque a droite, le grand tapis devant l'une, le petit devant
     l'autre, tous les deux a l'echelle reelle du kit. Les deux meubles sont
     dessines a une taille de reference (170 x 75 et 90 x 55, les mesures
     courantes) : ils donnent l'echelle, ils ne sont pas une promesse sur la
     piece du visiteur. Ils s'elargissent si le tapis les depasse, pour qu'un
     kit 60 x 100 ne sorte jamais de son meuble.

     Les deux meubles sont ALIGNES PAR LE BAS, a `GAP` au-dessus des tapis :
     les deux tapis reposent ainsi sur la meme ligne, ce qui se lit d'un coup
     d'oeil, alors que deux profondeurs de meuble differentes donnaient deux
     lignes de sol. */
  /* ── LA VUE WC, G17b ───────────────────────────────────────────────────
     Retour de Raph du 07/09 a 19h45 : « au bain tu dis petit devant lavabo,
     mais il y a aussi des WC ». Sur les 83 fiches dont un SKU commence par
     MONTU (releve Admin du 07/09, lecture seule), le petit tapis du kit n'est
     pas un rectangle pose devant le lavabo : il est DECOUPE EN U et il entoure
     le pied de la cuvette. Une scene qui le montre a plat devant un meuble
     vasque decrit un autre produit.

     CE QUI CHANGE, ET RIEN D'AUTRE : la MOITIE DROITE de la scene. Le grand
     tapis, la baignoire, l'echelle, les cotes, l'alignement par le bas : tout
     reste ce que G6.5 a pose. A droite, le meuble vasque devient un WC et le
     petit tapis prend sa forme reelle.

     LE WC EST POSE SUR LE TAPIS, ET C'EST TOUT LE PROPOS. Les autres meubles
     de cette scene sont A COTE du tapis, a `GAP` au-dessus ; celui-ci a son
     pied DANS l'echancrure, sinon le U ne veut rien dire. La cuvette descend
     donc jusqu'a l'interieur de l'echancrure, a 4 cm du fond : ces 4 cm sont
     le jeu de pose, celui qui fait qu'un contour se glisse autour du pied sans
     forcer.

     LES MESURES DU WC SONT UNE REFERENCE, PAS UNE PROMESSE, exactement comme
     les 170 x 75 de la baignoire : 40 cm de large, 18 cm de reservoir et 42 cm
     de cuvette, les mesures courantes d'un WC au sol. Elles donnent l'echelle.
     Ce qui est a l'echelle du PRODUIT, en revanche, c'est l'echancrure : elle
     est prise en proportion du petit tapis, jamais en valeur fixe, et un kit
     40 x 50 ne recoit donc pas l'echancrure d'un kit 50 x 60. */
  /* ── LA VUE LAVABO D'UN KIT EN U, G18a ────────────────────────────────────
     Retour de Raph du 08/09 a 00h47 : « le kit MONTU c'est un tapis 50x80 plus
     un petit 50x40 avec le U predecoupe ; le U a deux positions : autour d'un
     lavabo sur pied (il epouse la colonne et cache la tuyauterie) ou autour des
     WC ; la vue lavabo doit donc montrer le petit tapis en U autour du pied du
     lavabo, pas un rectangle ».

     CE QUI CHANGE : la vue « Devant le lavabo » d'un kit decoupe en U. G17b
     avait donne le U aux seuls WC et laisse le lavabo sur l'ancien dessin, un
     rectangle devant un meuble vasque. C'etait le meme produit dessine deux
     fois de deux formes differentes, ce qui est faux une fois sur deux : le
     petit tapis d'un kit MONTU est decoupe en U, ou qu'il aille.

     TROIS ETATS, ET UN SEUL PARAMETRE POUR LES DIRE : `vue` vaut « wc »,
     « lavabo », ou rien du tout. Rien du tout est le cas des 23 kits de bain
     qui ne sont pas des contours (aucune rangee de vues n'est rendue pour eux,
     `WC` est faux, `etat.vue` est nul) : ils gardent le meuble vasque et le
     petit tapis RECTANGLE, sans une ligne de changement. Un booleen n'aurait pas
     pu porter les trois.

     LES MESURES DU LAVABO SONT UNE REFERENCE, PAS UNE PROMESSE, comme les
     170 x 75 de la baignoire et les 40 de large du WC : 55 cm de large et 45 cm
     de profondeur de vasque, les mesures courantes d'un lavabo sur colonne.
     L'echancrure, elle, reste a l'echelle du PRODUIT : c'est la meme que dans la
     vue WC, prise en proportion du petit tapis. */
  var WC_REF = { l: 40, res: 18, cuve: 42, jeu: 4 };
  var LAV_REF = { l: 55, vasque: 45, jeu: 4 };
  function sceneBain(f, vue) {
    var versWC = vue === 'wc';
    var versLavaboU = vue === 'lavabo';
    var d = dimsOf(f);
    var K = f && f.kit ? f.kit : null;
    var GAP = 14, ECART = 26;
    var tubW = Math.max(170, d.l + 40), tubH = 75;
    var vanW = K ? Math.max(90, K.l + 30) : 0, vanH = 55;
    var gx = tubW / 2 - d.l / 2;
    var P = [];
    P.push({ t: 'furn', kind: 'table', round: false, x: 0, y: -(GAP + tubH), w: tubW, h: tubH });
    P.push({ t: 'rug', x: gx, y: 0, w: d.l, h: d.w, shape: 'rect' });
    P.push({ t: 'dim', x1: gx, y1: d.w + 22, x2: gx + d.l, y2: d.w + 22, label: d.l + ' cm' });
    P.push({ t: 'dim', x1: gx - 22, y1: 0, x2: gx - 22, y2: d.w, label: d.w + ' cm' });
    if (K) {
      var vx = tubW + ECART, px = vx + vanW / 2 - K.l / 2;
      if (versWC || versLavaboU) {
        /* L'ECHANCRURE, EN PROPORTION DU TAPIS. 42 % de sa largeur et 46 % de
           sa profondeur : sur un 50 x 60 cela fait 25 x 23 cm, sur un 40 x 50
           21 x 18 cm, c'est-a-dire l'ordre de grandeur d'un pied de cuvette
           dans les deux cas. La cuvette se cale DANS cette echancrure, elle
           n'a donc pas de largeur a elle : elle prend celle de l'echancrure
           moins le jeu de pose, et jamais plus, sinon elle mordrait le tapis. */
        var nw = K.l * 0.42, nd = K.w * 0.46;
        /* LE PIED TIENT DANS L'ECHANCRURE, jamais l'inverse : 6 cm de jeu au
           total, 3 de chaque cote, et un plancher pour que le trait reste
           visible sur un tres petit kit. */
        var pied = Math.max(8, nw - 6);
        /* LE TAPIS EST LE MEME DANS LES DEUX POSES : c'est un seul produit, et
           son echancrure ne change pas selon ce qu'elle entoure. */
        P.push({ t: 'rug', x: px, y: 0, w: K.l, h: K.w, shape: 'u', nw: nw, nd: nd });
        if (versWC) {
          var hautWC = WC_REF.res + WC_REF.cuve + (nd - WC_REF.jeu);
          P.push({
            t: 'furn', kind: 'wc',
            res: WC_REF.res, cuve: WC_REF.cuve, pied: pied,
            x: px + K.l / 2 - WC_REF.l / 2,
            y: -(WC_REF.res + WC_REF.cuve),
            w: WC_REF.l, h: hautWC
          });
        } else {
          /* MEME GEOMETRIE QUE LE WC, ET C'EST VOULU : la vasque contre le mur,
             sa colonne qui descend dans l'echancrure jusqu'a `jeu` centimetres
             du fond. Ce jeu de pose est le meme des deux cotes : c'est lui qui
             fait qu'un contour se glisse autour d'un pied sans forcer. */
          var hautLav = LAV_REF.vasque + (nd - LAV_REF.jeu);
          P.push({
            t: 'furn', kind: 'lavabo',
            vasque: LAV_REF.vasque, pied: pied,
            x: px + K.l / 2 - LAV_REF.l / 2,
            y: -LAV_REF.vasque,
            w: LAV_REF.l, h: hautLav
          });
        }
      } else {
        P.push({ t: 'furn', kind: 'counter', contour: true, x: vx, y: -(GAP + vanH), w: vanW, h: vanH });
        P.push({ t: 'rug', x: px, y: 0, w: K.l, h: K.w, shape: 'rect' });
      }
      /* LES DEUX COTES SONT LES MEMES DANS LES DEUX VUES : ce qui se commande
         est le format hors tout du petit tapis, echancrure ou pas. */
      P.push({ t: 'dim', x1: px, y1: K.w + 22, x2: px + K.l, y2: K.w + 22, label: K.l + ' cm' });
      P.push({ t: 'dim', x1: px + K.l + 22, y1: 0, x2: px + K.l + 22, y2: K.w, label: K.w + ' cm' });
    }
    /* LE VERDICT SUIT LA VUE, ET IL A UN REPLI PAR ETAGE : sans la chaine de la
       vue (un attribut qui n'aurait pas ete ecrit), on retombe sur celle du kit
       ordinaire plutot que sur une ligne vide. */
    var verdictBain = T.bain;
    if (versWC) verdictBain = T.wc || T.bain;
    else if (versLavaboU) verdictBain = T.lavabo || T.bain;
    return { prims: P, serre: false, verdict: verdictBain, avert: '' };
  }

  function sceneOrganic(f, room) {
    var d = dimsOf(f), Lg = d.l, W = d.w;
    var r = rug(f); r.w = Lg; r.h = W;
    var P = [r];
    if (room === 'chambre') {
      var bw = 160, bl = 200, bx = Lg / 2 - bw / 2, by = -(bl * 0.66);
      P.push({ t: 'furn', kind: 'bed', single: false, x: bx, y: by, w: bw, h: bl });
    } else {
      var sw = 210, sd = 88, sx = Lg / 2 - sw / 2, sy = -(sd - 16);
      P.push({ t: 'furn', kind: 'sofa', seats: 3, x: sx, y: sy, w: sw, h: sd });
    }
    var verdict = T.libre;
    P.push({ t: 'dim', x1: 0, y1: W + 22, x2: Lg, y2: W + 22, label: Lg + ' cm' },
           { t: 'dim', x1: -22, y1: 0, x2: -22, y2: W, label: W + ' cm' });
    return { prims: P, serre: false, verdict: verdict, avert: '' };
  }

  /* ══════════════════ CONTROLEUR ═════════════════════════════════════════ */
  var ROOM_FURN_DEF = { salon: '3', sam: '6', chambre: '140', exterieur: '3' };
  var TARGETS = {
    salon: { '2': [160, 230], '3': [200, 290], 'angle': [240, 330] },
    sam: { '4': [180, 250], '6': [200, 290], '8': [240, 330] },
    chambre: { '90': [160, 230], '140': [200, 290], '160': [240, 330], '180': [240, 330] },
    exterieur: { '2': [160, 230], '3': [200, 290], 'fauteuils': [160, 230], 'table': [200, 290] }
  };

  var SIZES = [];        /* les formats ACHETABLES, dans l'ordre du selecteur */
  var TOUS = [];         /* tous les formats lisibles, disponibilite comprise */
  /* `vue` (G17b) ne vit que la ou les deux poses du petit tapis sont offertes :
     une fiche MONTU, ou la section bain de la page guide.

     LA VUE DE DEPART EST LUE DANS LE DOM, PAS ECRITE ICI (fix round de la
     revue). Elle n'est pas la meme des deux cotes, et c'est voulu : une fiche
     MONTU vend un contour de WC, elle s'ouvre donc sur les WC ; la page guide
     ne parle d'aucun produit et s'ouvre sur le cas general, le lavabo. Deux
     defauts, une seule regle : la pastille que LIQUID a marquee `is-on` fait
     foi, exactement comme la largeur de depart du picker est lue dans son
     attribut. Le JS ne connait aucun des deux contextes.
     Repli sur « wc » si aucune pastille n'est marquee : la rangee existe, il
     faut bien dessiner quelque chose. */
  /* UN SELECTEUR SIMPLE, JAMAIS COMPOSE : ce fichier n'utilise que des
     selecteurs de classe ou d'attribut isoles, et `g34-tiroir-ouvert.mjs` le
     rejoue contre un DOM de papier qui compare des jetons entiers. Un
     `[data-cmt-vue].is-on` marcherait dans un navigateur et rendrait le banc
     aveugle, ce qui est la pire des deux issues. */
  function vueMarquee() {
    var b = root.querySelectorAll('[data-cmt-vue]');
    for (var i = 0; i < b.length; i++) {
      if (b[i].classList.contains('is-on')) return b[i].getAttribute('data-cmt-vue');
    }
    return null;
  }
  var etat = {
    room: ROOMS[0], furn: null, size: 0,
    vue: WC ? (vueMarquee() || 'wc') : null
  };

  /* Lecture du selecteur (§ 4.1). Le motif est cherche N'IMPORTE OU dans la
     chaine, jamais ancre : `data-size-value` porte `variant.title` sur les 677
     fiches mono-option. La regex accepte `x`, `X` et `×`, et ne s'appuie
     jamais sur le suffixe d'unite, qui peut se traduire. */
  /* Un couple de nombres, ou un diametre, n'importe ou dans la chaine. Jamais
     ancre, jamais appuye sur le suffixe d'unite, qui se traduit. */
  function mesure(t) {
    var rd = String(t).match(/[Øø]\s*(\d+)/);
    if (rd) return { dia: +rd[1] };
    var m = String(t).match(/(\d+)\s*[×xX]\s*(\d+)/);
    if (m) return { w: +m[1], l: +m[2] };
    return null;
  }
  function analyse(txt) {
    var t = String(txt || '');
    /* LE `+` EST LE MARQUEUR DE KIT. Hors bain il reste ce qu'il etait, un
       format qu'on n'ecrit pas dans la rangee : le moteur ne sait pas dessiner
       deux tapis dans une scene de salon, et il n'a pas a l'apprendre. En
       bain, c'est au contraire le format NORMAL, et le seul : on lit ses deux
       moities, la grande d'abord, comme le catalogue les ecrit. */
    if (t.indexOf('+') >= 0) {
      if (SHAPE !== 'bain') return null;
      var parts = t.split('+');
      var g = mesure(parts[0]);
      if (!g || g.dia != null) return null;
      var k = parts.length > 1 ? mesure(parts[1]) : null;
      if (k && k.dia == null) g.kit = k;
      return g;
    }
    return mesure(t);
  }
  function dispo(ligne) {
    if (ligne.getAttribute('data-available') === 'false') return false;
    if (ligne.getAttribute('aria-disabled') === 'true') return false;
    if (ligne.classList.contains('dw-picker__row--oos')) return false;
    return true;
  }
  function relitFormats() {
    TOUS = [];
    var vus = {};
    lignes().forEach(function (ligne) {
      var f = analyse(ligne.getAttribute('data-size-value'));
      if (!f) return;
      var cle = cleDe(f);
      if (vus[cle]) return;
      vus[cle] = 1;
      f.dispo = dispo(ligne);
      f.ligne = ligne;
      TOUS.push(f);
    });
    SIZES = TOUS.filter(function (f) { return f.dispo; });
  }
  var CLS_ACTIVE = PAGE ? 'is-on' : 'dw-picker__row--active';
  function ligneActive() {
    var l = lignes();
    for (var i = 0; i < l.length; i++) if (l[i].classList.contains(CLS_ACTIVE)) return l[i];
    for (var j = 0; j < l.length; j++) if (l[j].getAttribute('aria-selected') === 'true') return l[j];
    for (var k = 0; k < l.length; k++) if (dispo(l[k])) return l[k];
    return l[0] || null;
  }
  function ligneDe(id) {
    var l = lignes();
    for (var i = 0; i < l.length; i++) if (l[i].getAttribute('data-variant-id') === String(id)) return l[i];
    return null;
  }
  /* Le TEXTE affiche vient du contenu de `.dw-picker__row-dim`, qui porte
     deja le signe multiplie pose par Liquid, ou de `detail.size`. Jamais de
     l'attribut brut (§ 4.1, point 2 de la dependance `dw_size_only`). */
  function libelleLigne(ligne) {
    if (!ligne) return '';
    var dim = ligne.querySelector('.dw-picker__row-dim');
    return ((dim ? dim.textContent : ligne.getAttribute('data-size-value')) || '').trim();
  }

  /* LE PRIX DU FORMAT, LU ET JAMAIS FABRIQUE (ruling controleur du 05/09). Au
     390 le panneau couvre 92 svh : on compare des formats sans voir le prix.
     Le montant vient de `.dw-picker__row-price`, ecrit par Liquid via
     `cm-prix`, donc deja dans la langue, la devise et le format de nombre de
     la page, et deja le prix remise (la valeur barree vit a cote, dans
     `.dw-picker__compare`). Meme regle que `libelleLigne` : le selecteur fait
     foi. Sans element de prix, chaine vide et pas d'erreur. */
  function prixLigne(ligne) {
    if (!ligne || !ligne.querySelector) return '';
    var p = ligne.querySelector('.dw-picker__row-price');
    return ((p ? p.textContent : '') || '').trim();
  }

  /* La CLE d'un format, une seule ecriture pour les trois endroits qui la
     comparent : le releve, le calage sur la selection, la restitution du
     focus dans la rangee des formats. */
  function cleDe(f) {
    if (!f) return '';
    if (f.dia != null) return 'd' + f.dia;
    /* Le kit entre dans la cle : deux kits qui partagent leur grand tapis sont
       deux formats differents, et la cle sert a retrouver une pastille. */
    return f.w + 'x' + f.l + (f.kit ? '+' + f.kit.w + 'x' + f.kit.l : '');
  }
  function idxDeCle(cle) {
    for (var i = 0; i < SIZES.length; i++) if (cleDe(SIZES[i]) === cle) return i;
    return -1;
  }
  /* Cale l'index interne sur la ligne active du selecteur : le tiroir montre
     TOUJOURS ce qui est reellement choisi sur la fiche. */
  function caleSurSelection(ligne) {
    if (!ligne || !ligne.getAttribute) return;
    var f = analyse(ligne.getAttribute('data-size-value'));
    if (!f) return;
    var i = idxDeCle(cleDe(f));
    if (i >= 0) etat.size = i;
  }

  /* Le format conseille, correction D6. Sur un rond, `dimsOf()` rend un carre
     de cote egal au diametre : un Ø 300 etait juge comme un 300 x 300 face a
     une cible 200 x 290. On compare des SURFACES des que la forme n'est pas
     rectangulaire. Trente fiches rondes reparees. */
  function snapIdx(list, tw, tl) {
    var bi = 0, bd = 1e9;
    var surfaceCible = tw * tl;
    list.forEach(function (f, i) {
      var d = dimsOf(f), dist;
      if (SHAPE === 'round' || SHAPE === 'oval') {
        var s = f.dia != null ? Math.PI * (f.dia / 2) * (f.dia / 2) : d.w * d.l;
        dist = Math.abs(s - surfaceCible) / 100 + (s >= surfaceCible ? 0 : 60);
      } else {
        dist = Math.hypot(d.w - tw, d.l - tl) + (d.w >= tw && d.l >= tl ? 0 : 60);
      }
      if (dist < bd) { bd = dist; bi = i; }
    });
    return bi;
  }
  function recIdx() {
    if (SHAPE === 'organic' || etat.room === 'entree' || etat.room === 'cuisine') return -1;
    if (!SIZES.length) return -1;
    var tg = (TARGETS[etat.room] || {})[etat.furn];
    /* BERBÈRE rond, coin lecture : la cible des deux fauteuils du salon
       d'extérieur, le même dessin (`sceneLounge`). */
    if (BRB && etat.room === 'lecture') tg = TARGETS.exterieur.fauteuils;
    if (!tg) return -1;
    return snapIdx(SIZES, tg[0], tg[1]);
  }
  /* Ni la forme libre ni le bain n'ont de meuble a choisir : la premiere se
     pose seule, le second se pose devant deux meubles qui sont donnes. */
  function aFurn() { return SHAPE !== 'organic' && SHAPE !== 'bain' && !!ROOM_FURN_DEF[etat.room]; }
  function sceneFor(f) {
    /* Le bain passe AVANT tout le reste : sa scene ne depend ni de la piece ni
       du meuble, il n'a ni l'une ni l'autre. */
    if (SHAPE === 'bain') return sceneBain(f, WC ? etat.vue : null);
    if (SHAPE === 'organic') return sceneOrganic(f, etat.room);
    if (etat.room === 'salon') return sceneSalon(f, etat.furn || '3');
    if (etat.room === 'sam') return sceneSAM(f, parseInt(etat.furn, 10) || 6);
    if (etat.room === 'chambre') return sceneChambre(f, parseInt(etat.furn, 10) || 160);
    if (etat.room === 'cuisine') return sceneCuisine(f);
    if (etat.room === 'lecture') return sceneLounge(f);
    if (etat.room === 'exterieur') {
      if (etat.furn === 'table') return sceneSAM(f, 4);
      if (etat.furn === 'fauteuils') return sceneLounge(f);
      return sceneSalon(f, etat.furn === '2' ? '2' : '3');
    }
    return sceneEntree(f);
  }
  function surface(f) { var d = dimsOf(f); return d.w * d.l; }
  function plusGrandDispo(f) {
    /* BERBÈRE : plus grand est toujours possible jusqu'aux bornes de la
       matrice (sur mesure), et pas seulement parmi les tailles standard. */
    if (BRB) {
      var bd = dimsOf(f);
      var mx = Number(root.getAttribute('data-cm-max-w')) || 0;
      var ml = Number(root.getAttribute('data-cm-max-l')) || 0;
      return !(mx && ml && Math.min(bd.w, bd.l) >= mx && Math.max(bd.w, bd.l) >= ml);
    }
    var a = surface(f);
    for (var i = 0; i < SIZES.length; i++) if (surface(SIZES[i]) > a + 1) return true;
    return false;
  }

  /* LE NOM ACCESSIBLE DE LA SCENE. Partout, c'est le format : le dessin ne dit
     rien de plus que ce que « Votre selection » repete deux lignes plus bas. En
     BAIN, si : la scene place deux tapis a deux endroits precis, et c'est tout
     ce qu'elle apporte. Un lecteur d'ecran qui n'entend que
     « 50 x 80 + 40 x 50 cm » n'a rien recu de ce dessin. */
  function ariaScene(f) {
    if (SHAPE === 'bain' && f && f.kit) {
      /* G17b : la vue WC a son propre nom accessible. Les deux scenes ont les
         memes deux formats et ne montrent pas la meme chose : un lecteur
         d'ecran qui entendrait la meme phrase dans les deux n'apprendrait rien
         du bouton qu'il vient d'actionner. */
      /* G18a : TROIS SCENES, TROIS PHRASES. Sur un kit en U, la vue lavabo ne
         montre plus la meme chose que le kit ordinaire (un contour autour d'une
         colonne, et non un rectangle devant un caisson) : elle a donc son nom a
         elle. Hors kit en U, `WC` est faux et la phrase du kit ordinaire reste
         la seule. */
      var gabarit = T.sceneBain;
      if (WC && etat.vue === 'wc' && T.sceneWC) gabarit = T.sceneWC;
      else if (WC && etat.vue === 'lavabo' && T.sceneLavabo) gabarit = T.sceneLavabo;
      if (gabarit) {
        return tpl(gabarit, {
          '[g]': f.w + ' × ' + f.l + ' cm',
          '[p]': f.kit.w + ' × ' + f.kit.l + ' cm'
        });
      }
    }
    return libelleFormat(f);
  }

  /* Le dessin. Les etiquettes de cote sont posees APRES le SVG, en pourcentage
     du viewBox, qui porte le meme rapport que la boite (correction 2). */
  function dessine() {
    noteAdresse();
    if (!boite) return;
    var f = BRB ? saisie() : (SIZES[etat.size] || SIZES[0] || TOUS[etat.size] || TOUS[0]);
    var horsBornes = BRB ? majBornes(f) : false;
    if (BRB && !f) {
      /* Saisie vide : rien à dessiner, la rangée des tailles reste. */
      boite.innerHTML = '';
      if (elSel) elSel.textContent = '';
      if (elVerdictVal) elVerdictVal.textContent = '';
      peintFormats();
      majContinuer(null);
      return;
    }
    /* AUCUN FORMAT LISIBLE (selecteur en retard, ou remplace sous nos pieds) :
       il n'y a rien a emporter, donc pas de bouton de sortie plein Encre et
       vide en bas du panneau. La croix, le voile et Echap restent. */
    if (!f) { majContinuer(null); return; }
    var s = sceneFor(f);
    /* « Trop etroit » ne sert qu'a pousser vers plus grand. Si rien de plus
       grand n'existe, la phrase devient un conseil positif au lieu d'un
       reproche que le visiteur ne peut pas suivre. */
    var verdict = s.verdict, alerte = s.serre;
    if (s.serre && !plusGrandDispo(f)) { verdict = T.compact; alerte = false; }
    else if (s.avert) verdict = s.avert;
    /* BERBÈRE hors bornes : la saisie ne se commande pas en ligne. Le verdict
       dit les bornes (le texte du rappel, écrit par Liquid) et le bouton
       « Continuer avec … » part : il n'y a rien à emporter. */
    if (horsBornes) { verdict = (elBornes.textContent || '').replace(/\s+/g, ' ').trim(); alerte = true; }

    var out = render(s.prims);
    boite.innerHTML = out.svg;
    out.etiquettes.forEach(function (e) {
      var sp = document.createElement('span');
      /* `cmt-cote`, jamais `cmt-lab` : ce dernier est le libelle de groupe de
         meubles, pose DANS LE FLUX. Les deux ont porte le meme nom jusqu'a la
         revue du 05/09, et la cote, ecrite plus bas, gagnait a specificite
         egale : les libelles de meuble se posaient sur les pastilles. */
      sp.className = 'cmt-cote' + (e.or ? ' cmt-cote--or' : '');
      sp.style.left = (e.x / VBW * 100).toFixed(3) + '%';
      sp.style.top = (e.y / VBH * 100).toFixed(3) + '%';
      sp.textContent = e.t;
      boite.appendChild(sp);
    });
    boite.setAttribute('aria-label', ariaScene(f));
    /* LA LEGENDE DE MARGE SUIT LE DESSIN, pas la forme : le repere or n'existe
       que dans certaines scenes, et pour certains formats. Annoncer une
       couleur absente du dessin, c'est une legende qui ment. */
    if (legendeMarge) legendeMarge.hidden = !s.prims.some(function (o) { return o.t === 'deb'; });

    if (elVerdictVal) elVerdictVal.textContent = verdict || '';
    if (elVerdict) elVerdict.classList.toggle('cmt-verdict--alerte', !!alerte);
    var active = BRB ? null : ligneActive();
    if (elSel) elSel.textContent = libelleLigne(active) || libelleFormat(f);
    /* Le prix a cote du format, pour que comparer se fasse sans defiler. */
    if (elPrix && !BRB) elPrix.textContent = prixLigne(active) || prixLigne(f.ligne);
    peintFormats();
    majContinuer(horsBornes ? null : f);
    if (PAGE) majLien(f);
  }

  /* ── « Continuer avec 200 × 300 cm » (retour Raph du 05/09, 19h27) ─────────
     Le clic sur un format ne referme plus : il faut donc une sortie qui NOMME
     ce qu'on emporte. Le bouton porte `data-cmt-fermer` et passe par la meme
     delegation que la croix et le voile : un seul `ferme()`, un seul depilage
     d'historique, une seule restitution du focus. CE N'EST PAS UN AJOUT AU
     PANIER : le panneau ne vend rien, il rend la main a la colonne d'achat,
     deja a jour.

     TROIS CAS OU LE PIED PART, la croix, le voile et Echap restant les trois
     sorties : etat E5 ; aucun format lisible, `f` valant `null` ; locale
     muette. Un bouton plein Encre et VIDE serait pire que pas de bouton. */
  function majContinuer(f) {
    if (!elContinuer) return;
    var libelle = f ? libelleFormat(f) : '';
    var vide = !f || !libelle || (!BRB && !SIZES.length) || !T.continuer;
    if (pied) pied.hidden = vide;
    if (vide) { elContinuer.textContent = ''; return; }
    elContinuer.textContent = tpl(T.continuer, { '[f]': libelle });
  }

  /* La rangee des formats : les ACHETABLES, dans l'ordre du selecteur. Un clic
     applique le format et LAISSE LE TIROIR OUVERT (retour Raph du 05/09,
     19h27 : « quand tu viens selectionner une autre taille, direct ca te ferme
     le guide des tailles, tu ne peux pas comparer »). On ne clique jamais une
     ligne epuisee : c'est pourquoi les formats epuises ne sont pas listes.

     LA RANGEE EST REECRITE A CHAQUE DESSIN, et elle l'etait deja : la
     disponibilite et le format conseille changent dans la vie de la page. Tant
     que le clic refermait, personne ne pouvait avoir le focus dans une rangee
     reecrite. Maintenant si : la pastille sous le doigt est DETRUITE au milieu
     de son propre gestionnaire et le focus retombe sur `<body>`, hors du piege
     a tabulation. On releve donc la cle du format qui a le focus avant de
     vider, et on le rend apres. Par la CLE, pas par l'index : la liste peut
     avoir change de longueur entre les deux. */
  function peintFormats() {
    if (!elFormats) return;
    if (PAGE) { peintFormatsPage(); return; }
    if (BRB) { peintFormatsBrb(); return; }
    var focusCle = null;
    var actif = document.activeElement;
    if (actif && elFormats.contains(actif)) focusCle = actif.getAttribute('data-cmt-fmt');
    elFormats.innerHTML = '';
    var rec = recIdx();
    if (!SIZES.length) {
      /* Etat E5 : tout est epuise. La scene et les reperes restent, la rangee
         part, et la phrase ne sort que si toutes les lignes sont REELLEMENT
         indisponibles (defaut D4). */
      if (blocFormats) blocFormats.hidden = false;
      if (elEpuise) { elEpuise.textContent = T.epuise; elEpuise.hidden = false; }
      elFormats.hidden = true;
      if (focusCle) focusVers(croix);
      return;
    }
    /* Etat E2 : un seul format achetable, 109 fiches. Le bloc entier part,
       titre compris : une rangee a une seule pastille n'est pas un choix, et
       le reste du panneau garde tout son sens. Le format est deja nomme par
       « Votre selection », juste au-dessus. */
    if (blocFormats) blocFormats.hidden = SIZES.length < 2;
    if (elEpuise) elEpuise.hidden = true;
    elFormats.hidden = false;
    var aRendre = null;
    SIZES.forEach(function (f, i) {
      var cle = cleDe(f);
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cmt-format' + (i === etat.size ? ' is-on' : '');
      b.setAttribute('data-cmt-fmt', cle);
      b.setAttribute('aria-pressed', i === etat.size ? 'true' : 'false');
      b.appendChild(document.createTextNode(libelleFormat(f)));
      if (i === rec && T.conseille) {
        var badge = document.createElement('span');
        badge.className = 'cmt-badge';
        badge.textContent = T.conseille;
        b.appendChild(badge);
      }
      b.addEventListener('click', function () { applique(f); });
      elFormats.appendChild(b);
      if (focusCle && cle === focusCle) aRendre = b;
    });
    /* LA PASTILLE PEUT AVOIR DISPARU pendant qu'elle avait le focus : format
       parti en rupture, ou etat E2 qui masque le bloc entier. Le focus va
       alors a la croix : il ne quitte jamais le panneau et ne se pose jamais
       sur un element masque. */
    var rangeeVisible = !(blocFormats && blocFormats.hidden) && !elFormats.hidden;
    if (focusCle) focusVers(rangeeVisible && aRendre ? aRendre : croix);
  }

  /* ── MODE PAGE : LA RANGEE EST ECRITE PAR LIQUID, ON NE FAIT QUE LA MARQUER
     Sur la fiche, la rangee depend de la DISPONIBILITE, qui change dans la vie
     de la page : elle est donc refaite a chaque dessin. Sur la page guide, les
     formats sont ceux du CATALOGUE, ils ne bougent pas, et les pastilles sont
     aussi les lignes que `lignes()` relit : les reecrire les detruirait. On
     pose donc trois choses et rien d'autre : la pastille retenue, l'etat ARIA,
     et la pastille conseillee, qui suit le meuble choisi. */
  /* ── MODE BERBÈRE : la saisie, la rangée, les bornes ─────────────────── */
  function saisie() {
    if (!cfg) return null;
    var d = Number(cfg.getAttribute('data-cm-diametre'));
    if (SHAPE === 'round') return (isFinite(d) && d > 0) ? { dia: Math.round(d) } : null;
    var w = Number(cfg.getAttribute('data-cm-largeur'));
    var l = Math.round(Number(cfg.getAttribute('data-cm-longueur')) * 100);
    if (!isFinite(w) || w <= 0 || !isFinite(l) || l <= 0) return null;
    /* Les scènes posent la longueur à l'horizontale : le petit côté d'abord. */
    return { w: Math.min(w, l), l: Math.max(w, l) };
  }
  /* Le rappel des bornes, écrit par Liquid : il passe en alerte quand la
     saisie en sort, comme la ligne des bornes du configurateur. */
  var elBornes = BRB ? root.querySelector('[data-cmt-bornes]') : null;
  function majBornes(f) {
    if (!elBornes) return false;
    var hors = false;
    if (f) {
      var d = dimsOf(f);
      var a = [Number(root.getAttribute('data-cm-min-w')), Number(root.getAttribute('data-cm-max-w')),
               Number(root.getAttribute('data-cm-min-l')), Number(root.getAttribute('data-cm-max-l'))];
      hors = d.w < a[0] || d.w > a[1] || d.l < a[2] || d.l > a[3];
    }
    elBornes.classList.toggle('cmt-bornes--alerte', hors);
    return hors;
  }
  function surfaceDe(f) { return isRound(f) ? Math.PI * f.dia * f.dia / 4 : f.w * f.l; }
  function poseDansConfigurateur(f) {
    var detail = isRound(f) ? { diameter: f.dia } : { width: f.w, length: f.l / 100 };
    enApplication = true;
    try {
      document.dispatchEvent(new CustomEvent('couloir:set-dimensions', { detail: detail }));
    } catch (e) {} finally { enApplication = false; }
    relit();
    dessine();
  }
  function peintFormatsBrb() {
    var focusCle = null;
    var actif = document.activeElement;
    if (actif && elFormats.contains(actif)) focusCle = actif.getAttribute('data-cmt-fmt');
    elFormats.innerHTML = '';
    if (elEpuise) elEpuise.hidden = true;
    var s = saisie();
    var liste = SIZES.map(function (f) { return { f: f, std: true }; });
    if (s && idxDeCle(cleDe(s)) < 0) {
      /* La saisie prend son rang de surface parmi les tailles standard. */
      var i = 0;
      while (i < liste.length && surfaceDe(liste[i].f) <= surfaceDe(s)) i++;
      liste.splice(i, 0, { f: s, std: false });
    }
    if (blocFormats) blocFormats.hidden = !liste.length;
    elFormats.hidden = !liste.length;
    var rec = recIdx();
    var recCle = rec >= 0 && SIZES[rec] ? cleDe(SIZES[rec]) : '';
    var cleSaisie = s ? cleDe(s) : '';
    var aRendre = null;
    liste.forEach(function (o) {
      var cle = cleDe(o.f);
      var on = cle === cleSaisie;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cmt-format' + (on ? ' is-on' : '') + (o.std ? '' : ' cmt-format--saisie');
      b.setAttribute('data-cmt-fmt', cle);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.appendChild(document.createTextNode(libelleFormat(o.f)));
      if (o.std && cle === recCle && T.conseille) {
        var badge = document.createElement('span');
        badge.className = 'cmt-badge';
        badge.textContent = T.conseille;
        b.appendChild(badge);
      }
      if (o.std) b.addEventListener('click', function () { poseDansConfigurateur(o.f); });
      else b.addEventListener('click', function () { dessine(); });
      elFormats.appendChild(b);
      if (focusCle && cle === focusCle) aRendre = b;
    });
    if (focusCle) focusVers(aRendre || croix);
  }

  function peintFormatsPage() {
    var rec = recIdx();
    var b = elFormats.querySelectorAll('[data-cmt-fmt]');
    for (var i = 0; i < b.length; i++) {
      var j = idxDeCle(b[i].getAttribute('data-cmt-fmt'));
      var on = j >= 0 && j === etat.size;
      b[i].classList.toggle('is-on', on);
      b[i].setAttribute('aria-pressed', on ? 'true' : 'false');
      var badge = b[i].querySelector('.cmt-badge');
      if (badge) badge.hidden = !(j >= 0 && j === rec);
    }
  }

  /* ── MODE PAGE : L'ADRESSE DE LA COLLECTION FILTREE ────────────────────────
     Meme construction que `buildCTA()` de l'ancien moteur de page, au
     caractere pres : l'adresse localisee et le parametre de forme sont resolus
     par Liquid (`cm-url`, `cm-forme-locale`) et poses sur la racine ; il ne
     reste ici que le format, en valeur d'option (`160 x 230 cm`, avec la
     lettre x, jamais le signe multiplie : c'est ainsi que l'option est ecrite
     dans le catalogue). `filter.v.option.taille` n'est pas traduit : son nom
     suit la locale PRIMAIRE de la boutique. */
  function majLien(f) {
    if (!elLien || !f) return;
    var base = root.getAttribute('data-cm-base') || '';
    if (!base) return;
    var t = f.dia != null ? ('\u00d8' + f.dia + ' cm') : (f.w + ' x ' + f.l + ' cm');
    var p = ['filter.v.option.taille=' + encodeURIComponent(t)];
    var filtre = root.getAttribute('data-cm-filtre') || '';
    if (filtre) p.push(filtre);
    elLien.setAttribute('href', base + (base.indexOf('?') < 0 ? '?' : '&') + p.join('&'));
  }

  /* `preventScroll` : sans cette garde, rendre le focus ramenerait la rangee
     dans la fenetre a chaque format, alors qu'on regarde la scene, plus haut. */
  function focusVers(el) {
    if (!el || !el.focus) return;
    try { el.focus({ preventScroll: true }); } catch (e) { try { el.focus(); } catch (e2) {} }
  }

  /* SENS INVERSE : on CLIQUE la ligne du selecteur, jamais une indisponible.

     LE TIROIR NE SE REFERME PLUS ICI (retour Raph du 05/09, 19h27). C'etait
     bien LE CLIC qui fermait, pas l'evenement du selecteur : `applique()`
     appelait `ferme()` juste apres `ligne.click()`, et le lien se debranche
     par la seule suppression de cet appel. `surVariante` n'a jamais ferme quoi
     que ce soit : il relit et redessine, et sa garde `if (!ouvert) return`
     reste exacte.

     LES DEUX ECRITURES DE LA VITRINE SONT SYNCHRONES : casemira-size-picker.js
     ecoute le clic EN CAPTURE, repeint selecteur, prix et bouton, puis emet
     `cm:variant:instant` dans la meme pile ; casemira-dropdown-size-picker.js
     pose ensuite `dw-picker__row--active` et coche la radio. `surVariante` est
     donc deja passe quand on revient ici. On relit quand meme : si l'un des
     deux manque a l'appel, la scene suit le format clique au lieu d'attendre
     le `variant:changed` du theme, qui arrive apres un aller-retour reseau.
     Les deux passages sont idempotents. */
  function applique(f) {
    var ligne = f && f.ligne;
    /* Ligne passee en rupture depuis le dernier dessin. On ne clique pas, mais
       on RELIT : la rangee doit perdre cette pastille tout de suite, sinon le
       visiteur retape sur un bouton qui ne repond pas. */
    if (!ligne || !dispo(ligne)) { relit(); dessine(); return; }
    enApplication = true;
    try { ligne.click(); } catch (e) {} finally { enApplication = false; }
    relit();
    dessine();
  }

  /* Les rangees de choix sont ecrites par Liquid : le JS marque l'active et
     montre le bon groupe de meubles. Aucun libelle n'est fabrique ici. */
  function peintPieces() {
    if (!rangeePieces) return;
    var b = rangeePieces.querySelectorAll('[data-cmt-piece]');
    for (var i = 0; i < b.length; i++) {
      var on = b[i].getAttribute('data-cmt-piece') === etat.room;
      b[i].classList.toggle('is-on', on);
      b[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
  }
  function peintMeubles() {
    var groupes = root.querySelectorAll('[data-cmt-furn]');
    for (var i = 0; i < groupes.length; i++) {
      var mien = aFurn() && groupes[i].getAttribute('data-cmt-furn') === etat.room;
      groupes[i].hidden = !mien;
      if (!mien) continue;
      var opts = groupes[i].querySelectorAll('[data-cmt-furn-v]');
      for (var j = 0; j < opts.length; j++) {
        var on = opts[j].getAttribute('data-cmt-furn-v') === etat.furn;
        opts[j].classList.toggle('is-on', on);
        opts[j].setAttribute('aria-pressed', on ? 'true' : 'false');
      }
    }
  }
  function meubleParDefaut() { etat.furn = aFurn() ? ROOM_FURN_DEF[etat.room] : null; }
  /* Les deux pastilles de vue (G17b), peintes comme les autres rangees : le
     JS marque l'active, il ne fabrique aucun libelle. La rangee n'existe que
     sur un kit MONTU ; ailleurs, `rangeeVues` est nul et rien ne s'execute. */
  var rangeeVues = root.querySelector('[data-cmt-vues]');
  function peintVues() {
    if (!rangeeVues) return;
    var b = rangeeVues.querySelectorAll('[data-cmt-vue]');
    for (var i = 0; i < b.length; i++) {
      var on = b[i].getAttribute('data-cmt-vue') === etat.vue;
      b[i].classList.toggle('is-on', on);
      b[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
  }

  root.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    /* MODE PAGE : LE CLIC SUR UN FORMAT PASSE PAR ICI, ET PAS PAR `applique()`.
       Sur la fiche, chaque pastille recoit son ecouteur au moment ou la rangee
       est reconstruite, et `applique()` clique la ligne du selecteur. Sur la
       page, la rangee est ecrite par Liquid et n'est jamais reconstruite : il
       n'y a donc aucun moment ou poser un ecouteur par pastille, et rien a
       commander. Un seul ecouteur, en delegation sur l'hote, deplace l'index
       et redessine ; `dessine()` met le lien de collection a jour. */
    if (PAGE) {
      var fmt = e.target.closest('[data-cmt-fmt]');
      if (fmt) {
        var iFmt = idxDeCle(fmt.getAttribute('data-cmt-fmt'));
        if (iFmt >= 0) { etat.size = iFmt; dessine(); }
        return;
      }
    }
    var p = e.target.closest('[data-cmt-piece]');
    if (p) {
      etat.room = p.getAttribute('data-cmt-piece');
      meubleParDefaut();
      peintPieces(); peintMeubles(); dessine();
      return;
    }
    var v = e.target.closest('[data-cmt-vue]');
    if (v) {
      etat.vue = v.getAttribute('data-cmt-vue');
      peintVues(); dessine();
      return;
    }
    var m = e.target.closest('[data-cmt-furn-v]');
    if (m) {
      etat.furn = m.getAttribute('data-cmt-furn-v');
      peintMeubles(); dessine();
    }
  });

  /* Relecture de l'etat DOM, a l'ouverture et a chaque changement de variante
     TANT QUE LE TIROIR EST OUVERT. Correction du defaut D7 : l'ancien moteur
     se relancait a chaque clic et remettait tout a zero. */
  function relit(ligne) {
    relitFormats();
    if (BRB) { etat.size = idxDeCle(cleDe(saisie())); return; }
    caleSurSelection(ligne || ligneActive());
    if (etat.size >= SIZES.length) etat.size = 0;
  }
  /* UN SEUL DESSIN PAR CLIC SUR UN FORMAT. `applique()` clique la ligne du
     selecteur, qui emet `cm:variant:instant` DANS LA MEME PILE : sans ce
     drapeau, `surVariante` dessinait, puis `applique()` redessinait le meme
     etat au retour. Ce qui est saute ici est repris deux lignes plus loin,
     dans les deux mondes. Le drapeau ne couvre QUE le `ligne.click()`, et un
     `finally` le rabaisse meme sur exception. */
  var enApplication = false;
  function surVariante(e) {
    if (!ouvert || enApplication) return;
    var ligne = (e && e.detail && e.detail.id != null) ? ligneDe(e.detail.id) : null;
    relit(ligne || ligneActive());
    dessine();
  }

  /* LA SORTIE DU MODE PAGE. Tout ce qui suit n'existe que pour un panneau :
     verrou, historique, piege a focus, geste, declencheurs. Rien de ce qui
     precede n'appelle ce qui suit autrement que par declaration de fonction,
     donc remontee (`noteAdresse()` sort sur `pousse` valant `undefined`). */
  if (PAGE) {
    meubleParDefaut();
    relit();
    peintMeubles();
    peintVues();
    dessine();
    return;
  }

  /* OUVERTURE, FERMETURE, VERROU. Recopie du tiroir couloir : les deux
     panneaux sont indiscernables parce qu'ils partagent le meme MOTIF, pas
     parce qu'ils partagent un fichier. */
  var barrePosee = false;
  function mesureLaBarre() {
    if (racine.classList.contains('cmt-lock')) return;
    racine.style.setProperty('--cmt-sbw', (window.innerWidth - racine.clientWidth) + 'px');
    barrePosee = true;
  }
  window.addEventListener('resize', function () {
    mesureLaBarre();
    if (ouvert) dessine();
  });

  /* ON NE RETIRE QUE CE QU'ON A POSE, ET SEULEMENT SI PLUS PERSONNE NE LA
     TIENT. `cm-over` est partagee par six surcouches ; la retirer en aveugle
     rallumerait le bandeau de consentement PAR-DESSUS une surcouche vivante.
     Les revendicateurs sont NOMMES un par un, jamais devines par un selecteur
     large (lecon de la vague 4) :
       · `cmk-open`  le tiroir panier (`casemira-cart.js`) ;
       · `cmg-lock`  le guide des tailles couloir (`casemira-guide-tiroir.js`) ;
       · `cmq-locked` la mini-fiche des collections (`casemira-collection-plus.js`) ;
       · `search-open` / `search-is-open` la recherche predictive du theme ;
       · `menu-drawer[open]` le tiroir de navigation.
     `cmt-lock` est NOTRE marque : absente d'ici, retiree avant d'interroger
     les autres, et ajoutee en retour dans les cinq arbitres. */
  function quelquUnDAutreLaTient() {
    return (
      racine.classList.contains('cmk-open') ||
      racine.classList.contains('cmg-lock') ||
      racine.classList.contains('cmq-locked') ||
      document.body.classList.contains('search-open') ||
      document.body.classList.contains('search-is-open') ||
      !!document.querySelector('menu-drawer[open]')
    );
  }
  function verrouille() {
    if (!barrePosee) mesureLaBarre();
    racine.classList.add('cmt-lock');
    /* Regle Une Surcouche a la Fois (DESIGN.md) : `cm-over` efface la bulle
       de chat et le bandeau de consentement, poses a des profondeurs qu'aucun
       palier nomme ne peut depasser. */
    racine.classList.add('cm-over');
  }
  function deverrouille() {
    racine.classList.remove('cmt-lock');
    if (!quelquUnDAutreLaTient()) racine.classList.remove('cm-over');
  }

  var ouvert = false;
  var declencheur = null;
  var minuteur = null;
  var pousse = false;      /* une entree d'historique nous appartient */
  var popAttendu = false;  /* le pop que NOUS avons demande, a ignorer */

  /* L'HISTORIQUE, memes gardes que le tiroir couloir. Sans entree empilee, le
     geste de retour fait QUITTER LA PAGE au lieu de refermer la feuille. On
     n'empile pas par-dessus une entree qui n'est pas a nous : le panier empile
     aussi, et son `popstate` se referme sur tout pop non demande. */
  function empile() {
    if (pousse) return;
    if (racine.classList.contains('cmk-open')) return;
    try { history.pushState({ cmtGuide: 1 }, '', location.href); pousse = true; urlVivante = location.href; }
    catch (e) { pousse = false; }
  }
  /* ── L'ADRESSE APRES LA SORTIE, ET IL Y A DEUX SORTIES ────────────────────
     Notre entree a ete empilee avec l'adresse d'AVANT l'ouverture. Chaque
     format choisi ensuite fait ecrire `?variant=` par le `replaceState` de
     casemira-size-picker.js, qui ecrase NOTRE entree et pas la precedente : le
     `history.back()` de la sortie ramenait donc l'adresse d'avant, sans le
     format retenu, alors que la fiche l'affiche.

       · SORTIE QUE NOUS DEMANDONS (croix, voile, Echap, « Continuer avec … ») :
         `depile()` retient l'adresse (`urlSortie`) juste avant `history.back()`
         et le `popstate` la repose sur l'entree d'arrivee ;
       · GESTE DE RETOUR du visiteur (G4.1, la cinquieme sortie, laissee de cote
         au fix round de G3.4) : le navigateur depile NOTRE entree sans nous
         prevenir, et l'adresse a deja recule quand `popstate` arrive. On ne
         peut donc pas la lire a ce moment-la : `urlVivante` la releve tant que
         notre entree existe, a l'empilage puis a chaque dessin - le seul
         instant ou elle a pu bouger, puisque c'est le clic sur un format qui
         la fait bouger.

     Dans les deux cas `replaceState` : aucune entree ajoutee, `history.state`
     repasse tel quel, et le geste de retour suivant quitte toujours la page. */
  var urlSortie = '';   /* l'adresse d'avant NOTRE `history.back()`         */
  var urlVivante = '';  /* l'adresse tant que notre entree est empilee      */
  /* ── ON NE RELEVE PAS UNE ADRESSE A LAQUELLE LE NAVIGATEUR VIENT DE REVENIR
     (G4.9, controle A5b de la fenetre G3). Nous ne sommes PAS le seul ecouteur
     de `popstate` de la fiche, et nous ne sommes pas le premier :
     `casemira-size-picker.js` l.1663 y appelle `sync()` -> `paint()`, qui emet
     `cm:variant:instant` (l.942). Son `<script>` est rendu par
     `casemira-pdp-reskin` (main-product l.156), le notre par
     `casemira-guide-tailles` (l.394) : les deux sont `defer`, il passe donc
     avant nous. Le panneau encore ouvert se redessine sur cet evenement, donc
     `noteAdresse()` s'executait APRES le depilage et AVANT notre propre
     ecouteur : `urlVivante` prenait l'adresse d'AVANT l'ouverture, et notre
     restitution devenait un coup pour rien.

     LE TEST EST NOTRE MARQUE D'ETAT, PAS UN DRAPEAU. `history.state` porte
     `cmtGuide` tant que NOTRE entree est celle du dessus, et le
     `replaceState(history.state, ...)` du selecteur la repasse tel quel. Apres
     un depilage, `history.state` est celui de l'entree PRECEDENTE : la marque
     n'y est pas, et on ne note rien. Un tiers qui ecraserait l'etat (l'ancre
     douce de `casemira-pdp-reskin.js` l.558 passe `null`) nous fait seulement
     garder la derniere adresse relevee : degradation, jamais fausse adresse. */
  function noteAdresse() {
    if (!pousse) return;
    var st = null;
    try { st = history.state; } catch (e) { st = null; }
    if (!st || !st.cmtGuide) return;
    urlVivante = location.href;
  }
  function depile() {
    if (!pousse) return;
    pousse = false;
    popAttendu = true;
    urlSortie = location.href;
    urlVivante = '';
    try { history.back(); } catch (e) { popAttendu = false; urlSortie = ''; }
  }
  window.addEventListener('popstate', function () {
    if (popAttendu) {
      popAttendu = false;
      if (urlSortie && location.href !== urlSortie) {
        try { history.replaceState(history.state, '', urlSortie); } catch (e) {}
      }
      urlSortie = '';
      return;
    }
    if (!pousse) return;
    if (ouvert) {
      if (urlVivante && location.href !== urlVivante) {
        try { history.replaceState(history.state, '', urlVivante); } catch (e) {}
      }
      urlVivante = '';
      pousse = false;
      ferme(true);
    }
  });

  function dureeSortie() {
    var v = getComputedStyle(racine).getPropertyValue('--dur-3').trim();
    var ms = parseFloat(v);
    if (!isFinite(ms)) return 420;
    if (v.slice(-2) !== 'ms' && v.slice(-1) === 's') ms *= 1000;
    return ms;
  }
  function focusables() {
    if (!panneau) return [];
    var s = 'button:not([disabled]):not([aria-disabled="true"]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    return Array.prototype.slice.call(panneau.querySelectorAll(s)).filter(function (el) {
      return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
    });
  }
  function clavier(e) {
    if (!ouvert) return;
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); ferme(); return; }
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) return;
    var premier = f[0], dernier = f[f.length - 1], a = document.activeElement;
    if (e.shiftKey && (a === premier || !panneau.contains(a))) { e.preventDefault(); dernier.focus(); }
    else if (!e.shiftKey && (a === dernier || !panneau.contains(a))) { e.preventDefault(); premier.focus(); }
  }

  /* ── `cmt-ouvert` : L'OUVERTURE LOGIQUE, ET ELLE N'EST PAS `cmt-lock` ─────
     Meme paire que `cmg-ouvert` / `cmg-lock` dans `casemira-guide-tiroir.js`,
     meme raison, et le pave complet est la-bas.

       · `cmt-lock` dit « le panneau OCCUPE ENCORE L'ECRAN » : elle ne part que
         dans `fin()`, `dureeSortie() + 40` ms apres la fermeture logique. Elle
         sert l'arbitrage de `cm-over`, et rien d'autre ;
       · `cmt-ouvert` dit « le guide est ouvert » au sens de la machine a
         etats : posee et retiree SYNCHRONIQUEMENT, avant tout differe, et
         COLLEE a `ouvert = true` dans `ouvre` plutot qu'en tete. Entre les
         deux il y a `verrouille()`, `relit()`, `peintPieces()`,
         `peintMeubles()` et `dessine()` : si l'un levait, `ouvert` resterait
         faux et la marque resterait posee, personne pour la retirer.

     Le panier lit `cmt-ouvert` pour decider s'il empile une entree
     d'historique. Sur `cmt-lock` il serait aveugle pendant les 460 ms de la
     sortie, et le visiteur qui ferme le guide puis ouvre le panier dans la
     foulee perdrait la page a son geste de retour. */
  function ouvre(dep) {
    if (ouvert) return;
    /* LE TIROIR QUI S'OUVRE NE TRAINE PAS LE GESTE DU PRECEDENT (fix round 1
       de la revue G10). `bouge` dit « un glissement vient de deplacer le
       panneau » et sert au clic du voile a ne pas prendre un clic fantome pour
       un tap. Il n'etait remis a zero que par un `touchstart` ou un
       `pointerdown` : ferme au geste puis rouvert par un chemin qui n'en
       envoie pas (le clavier, un declencheur active au clavier, un script),
       le tiroir gardait le drapeau leve et refusait UNE fois de se fermer au
       voile. Une seconde d'inattention pour le visiteur, et rien qui se
       raconte. Il part avec l'ouverture, ou il n'a plus aucun sens. */
    bouge = false;
    declencheur = dep || null;
    if (minuteur) { clearTimeout(minuteur); minuteur = null; }

    /* Le panneau se cale sur la FENETRE : un seul ancetre portant `transform`,
       `filter`, `perspective` ou `contain: paint` en ferait le bloc conteneur
       d'un enfant `position: fixed`. Gratuit, l'element etant `hidden`. */
    if (root.parentNode !== document.body) document.body.appendChild(root);

    root.hidden = false;
    verrouille();

    relit();
    peintPieces();
    peintMeubles();
    peintVues();
    dessine();

    /* Un reflow force, une seule fois : sans lui le navigateur regroupe le
       passage de `hidden` et l'ajout de `is-open` dans le meme calcul de
       style, et la transition d'entree n'a pas de point de depart. */
    void root.offsetWidth;
    root.classList.add('is-open');
    racine.classList.add('cmt-ouvert');
    ouvert = true;

    document.addEventListener('keydown', clavier, true);
    document.addEventListener('cm:variant:instant', surVariante);
    document.addEventListener('variant:changed', surVariante);
    if (BRB) document.addEventListener('berbere:change', surVariante);
    majDeclencheurs(true);
    empile();
    if (croix) setTimeout(function () { try { croix.focus(); } catch (e) {} }, 40);
  }

  function ferme(depuisHistorique) {
    if (!ouvert) return;
    /* ── LE GESTE NE SURVIT PAS A LA FERMETURE, QUELLE QU'ELLE SOIT ────────
       (fix round 1 de la revue G10.) `ferme()` a QUATRE appelants qui ne
       passent pas par le geste : la croix, Echap, le voile et `popstate`. Un
       doigt encore pose au moment ou l'un d'eux tire laissait `cmt-drag` sur
       la racine et `--cmt-dy` sur le panneau : le panneau sortait sans
       transition, et il RENTRAIT decale a l'ouverture suivante, puisque
       personne n'allait plus les retirer (le `touchend` d'un tiroir ferme sort
       sur `if (!glisse)`... mais seulement si le geste a ete arme, et un geste
       arme sur un tiroir qu'on vient de fermer autrement n'a plus de porte).
       Le nettoyage est mis ICI plutot que dans chaque appelant : une seule
       porte de fermeture, un seul menage. Quand c'est le GESTE qui ferme,
       `gFin` a deja repose le panneau et remis `glisse` a faux : l'appel sort
       tout de suite, il ne coute rien et il ne defait rien. */
    gAbandonne();
    /* EN TETE, AVANT TOUT DIFFERE : voir le pave de `cmt-ouvert` sur `ouvre`.
       `depile()` est appele quelques lignes plus bas et le panier peut etre
       sollicite dans la milliseconde qui suit ; la marque doit deja etre
       partie. `cmt-lock`, elle, ne part que dans `fin()`. */
    racine.classList.remove('cmt-ouvert');
    ouvert = false;
    root.classList.remove('is-open');
    document.removeEventListener('keydown', clavier, true);
    document.removeEventListener('cm:variant:instant', surVariante);
    document.removeEventListener('variant:changed', surVariante);
    document.removeEventListener('berbere:change', surVariante);
    majDeclencheurs(false);
    if (!depuisHistorique) depile();

    /* Le verrou ne se leve qu'une fois le panneau sorti : le lever tout de
       suite rendrait la barre de defilement pendant le mouvement, et la page
       sauterait de sa largeur sous les yeux du visiteur. */
    var fin = function () { root.hidden = true; deverrouille(); minuteur = null; };
    var d = dureeSortie();
    if (d <= 20) fin();
    else minuteur = setTimeout(fin, d + 40);

    if (declencheur && declencheur.focus) { try { declencheur.focus(); } catch (e) {} }
    declencheur = null;
  }

  function majDeclencheurs(e) {
    var l = document.querySelectorAll('.cm-guide-tiroir-trigger');
    for (var i = 0; i < l.length; i++) l[i].setAttribute('aria-expanded', e ? 'true' : 'false');
  }

  /* ══════════════════════════════════════════════════════════════════════
     LE GESTE DE FERMETURE, REPRIS DU PANIER                   G10, 07/09/2026
     ----------------------------------------------------------------------
     RAPH, 07/09 A 00h31 : « tu peux les re-slider pour les fermer, pas oblige
     d'appuyer sur la croix, une animation fluide ultra smooth, comme le
     panier ».

     « COMME LE PANIER » EST PRIS AU MOT. Ce bloc est le § 2 de
     `assets/casemira-cart.js` porte ici, avec ses cinq seuils a l'identique,
     sa fenetre de vitesse de 90 ms, son elastique court a contresens, sa
     regle du `touchmove` NON PASSIF et sa lecon centrale : la propriete
     personnalisee est posee sur le PANNEAU et la classe sur la RACINE DU
     TIROIR, jamais sur `<html>`. Une propriete personnalisee est HERITEE :
     la reposer sur la racine du document invalide le style de tout le
     document a chaque image, pour deplacer un seul element (35 ms par pas
     mesures le 30/08 sur la feuille de filtres avant correction).
     Ecrire d'autres seuils ici ferait deux gestes qui se ressemblent, ce qui
     est pire que deux gestes qui different.

     L'AXE SUIT L'OUVERTURE, PARCE QUE LA FEUILLE DE STYLE LE FAIT DEJA. Sous
     768 px le panneau monte du bas (`translateY(100%)`) : on le glisse VERS
     LE BAS. Au-dessus, il vient du bord droit (`translateX(100%)`) : on le
     glisse VERS LA DROITE. La frontiere est celle du CSS, ecrite une fois
     ici sous le meme nombre.

     POURQUOI `(pointer: coarse)` ET PAS UNE LARGEUR. Le brief demande le
     geste sur telephone. Une largeur dirait « petite fenetre », pas « doigt » :
     une fenetre de bureau retrecie prendrait le geste sans jamais pouvoir le
     faire, et une tablette large en portrait le perdrait alors qu'elle ouvre
     le panneau par le cote. Le pointeur grossier est la question qu'on pose
     vraiment. C'est aussi ce qui protege la souris : au bureau, un panneau
     qui part parce que la main a derive de 80 px serait une perte de saisie.

     LES TROIS ZONES QUI L'ARMENT, ET LE CONFLIT QU'ELLES EVITENT
       · l'EN-TETE (`.cmt-tete`), qui est la poignee de ce tiroir : rien n'y
         est cliquable sauf la croix, et un bouton n'arme jamais rien ;
       · le VOILE, au doigt seulement, comme le panier ;
       · le CORPS DEFILANT, et SEULEMENT quand il est deja en haut de son
         defilement (`scrollTop === 0`) ET dans le sens de la fermeture.
         C'est le choix du panier, et c'est le seul qui ne prend pas un
         defilement pour une fermeture : le contenu de ces tiroirs defile
         (scene, legende, formats, « A retenir »), et un geste vers le bas au
         milieu de la liste doit remonter la liste, pas fermer le panneau.
         Le controle est refait dans `gDecide` : entre l'appui et le sixieme
         pixel, le doigt a pu faire defiler.

     CE QUI N'ARME RIEN, ET C'EST LA REGLE QUI PROTEGE LE RESTE DU TIROIR.
     `button, a[href], input, select, textarea, [role="button"]` : la croix, le
     stepper de marches, le champ de longueur, les pastilles de format et le
     bouton de sortie sont tous dedans. Un tap sur un format ne peut donc pas
     devenir un glissement, et la regle G3.4 (le tiroir RESTE OUVERT quand on
     choisit un format) tient sans avoir a se defendre. C'est aussi la lecon du
     panier sur `setPointerCapture`, qui DEPLACE LA CIBLE DU `click` : armer
     depuis un bouton volerait le clic de ce bouton.

     LA SORTIE PASSE PAR `ferme()`, SANS ARGUMENT, exactement comme la croix.
     Donc : `depile()`, la restitution de `urlSortie` / `urlVivante` avec son
     `?variant=`, le focus rendu au declencheur, le minuteur de `fin()`. Un
     second chemin de fermeture aurait ete un second historique.

     MOUVEMENT REDUIT. Rien a ajouter : les tokens ramenent `--dur-3` a 1 ms,
     la feuille supprime la transition du panneau, `dureeSortie()` rend alors
     une valeur sous 20 ms et `ferme()` remet la page en etat dans la meme
     pile. Le panneau ne joue aucune sortie animee, le retour elastique est
     instantane, et le suivi du doigt reste : ce n'est pas une animation, c'est
     la main du visiteur.
     ══════════════════════════════════════════════════════════════════════ */

  /* Les cinq seuils du panier, valeur pour valeur (`casemira-cart.js` § 0). */
  var G_SLOP = 6;        /* px : en deca, c'est un tap                       */
  var G_DISTANCE = 80;   /* px : au-dela, on ferme                           */
  var G_VELOCITY = 0.5;  /* px/ms : un geste vif vaut une longue distance    */
  var G_WINDOW = 90;     /* ms : la vitesse se lit sur un lancer             */
  var G_RUBBER = 56;     /* px : course maximale a contresens                */
  var G_RUBBER_F = 0.15; /* 112 px de geste ne remontent le panneau que de 18 */
  var G_COTE = 768;      /* px : la frontiere feuille / tiroir de la feuille  */

  var glisse = false;
  var arme = false;
  var idPointeur = null;
  var d0 = 0;      /* la coordonnee de depart sur l'axe du geste */
  var t0 = 0;
  var course = 0;  /* la course pleine du panneau, mesuree UNE FOIS */
  var trace = [];
  var bouge = false;

  function auDoigt() {
    try {
      return !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
    } catch (e) {
      return false;
    }
  }

  /* L'AXE EST POSE PAR LA MEME QUESTION QUE LA FEUILLE DE STYLE, ET C'EST
     VOLONTAIREMENT UN `matchMedia` PLUTOT QU'UN `innerWidth` (fix round 1 de
     la revue G10). La feuille bascule le panneau du bas vers le cote sur
     `@media (min-width: 768px)` : si le JS repond a une AUTRE question, les
     deux peuvent se contredire, et le doigt pousse alors le panneau sur un axe
     ou il ne sort pas.
     Ils se contredisent pour de vrai : `window.innerWidth` est la fenetre
     VISUELLE, celle que le pincement retrecit et que le navigateur elargit
     quand une page deborde ; `(min-width: …)` interroge la fenetre de MISE EN
     PAGE, celle qui a decide du style. Releve au banc du 07/09, fiche rendue
     sans sa feuille de theme : `clientWidth` 390, `innerWidth` 1560. Le meme
     ecart se produit chez un visiteur qui a pince pour zoomer.
     Le repli sur `innerWidth` existe pour les navigateurs sans `matchMedia`,
     qui n'auraient de toute facon pas de `(pointer: coarse)` et n'armeraient
     donc jamais le geste. */
  function axe() {
    try {
      if (window.matchMedia) return window.matchMedia('(min-width: ' + G_COTE + 'px)').matches ? 'x' : 'y';
    } catch (e) {
      /* repli */
    }
    return window.innerWidth >= G_COTE ? 'x' : 'y';
  }
  function coord(x, y) { return axe() === 'x' ? x : y; }

  function echantillon(d, t) {
    trace.push({ d: d, t: t });
    while (trace.length > 2 && t - trace[0].t > G_WINDOW) trace.shift();
  }

  function vitesse(d, t) {
    var a = trace.length ? trace[0] : { d: d0, t: t0 };
    return (d - a.d) / Math.max(1, t - a.t);
  }

  function decalage(dd) {
    if (dd >= 0) return dd;
    /* A contresens : elastique COURT, le facteur du panier. */
    return Math.max(-G_RUBBER, dd * G_RUBBER_F);
  }

  function corpsDefilant() { return root.querySelector('.cmt-corps'); }

  /* LA COURSE EST MESUREE UNE SEULE FOIS, A L'ARMEMENT. Elle ne sert qu'au
     fondu du voile ; la lire a chaque image mettrait un calcul de mise en page
     DANS la boucle du geste, c'est-a-dire le contraire de 60 images par
     seconde. Le panneau ne change pas de taille pendant qu'un doigt le
     pousse : une mesure suffit. */
  function mesureCourse() {
    course = 0;
    if (!panneau || !panneau.getBoundingClientRect) return;
    try {
      var r = panneau.getBoundingClientRect();
      course = axe() === 'x' ? r.width : r.height;
    } catch (e) {
      course = 0;
    }
  }

  function gesteArme() {
    root.classList.add('cmt-drag');
    if (panneau && panneau.style) panneau.style.willChange = 'transform';
    mesureCourse();
  }

  /* Le panneau suit le doigt en TRANSLATION SEULE (regle Transform ou Rien) et
     le voile s'estompe dans la meme proportion : c'est la seule chose que ce
     bloc ajoute au motif du panier, et c'est ce que le brief demande. Une
     opacite ne deplace rien et ne coute aucun calcul de mise en page. */
  function gesteBouge(dd) {
    if (!panneau || !panneau.style) return;
    panneau.style.setProperty(axe() === 'x' ? '--cmt-dx' : '--cmt-dy', Math.round(dd) + 'px');
    if (!root.style || !course) return;
    var part = dd > 0 ? Math.min(1, dd / course) : 0;
    root.style.setProperty('--cmt-fondu', String(Math.round((1 - part) * 100) / 100));
  }

  /* Le retour elastique EST le retrait de la propriete : la transition du
     panneau reprend dans la meme image et ramene le `transform` a zero, sur
     `--dur-3` et `--ease-both`, les durees de DESIGN.md. */
  function gesteRepose() {
    root.classList.remove('cmt-drag');
    if (root.style) root.style.removeProperty('--cmt-fondu');
    if (panneau && panneau.style) {
      panneau.style.removeProperty('--cmt-dy');
      panneau.style.removeProperty('--cmt-dx');
      panneau.style.willChange = '';
    }
  }

  function gDebut(cible, x, y, t, id, capture, type) {
    if (glisse) return true;
    bouge = false;
    if (!ouvert || !auDoigt()) return false;
    if (!cible || typeof cible.closest !== 'function') return false;

    /* UN GESTE NE PART JAMAIS D'UNE COMMANDE (lecon du panier, vague 1) :
       `setPointerCapture` DEPLACE LA CIBLE DU `click`, et la croix, le
       stepper, le champ de longueur, les pastilles de format et le bouton de
       sortie deviendraient sans effet. */
    if (cible.closest('button, a[href], input, select, textarea, [role="button"]')) return false;

    /* LE VOILE N'ARME AUCUN GESTE A LA SOURIS (lot I du panier) : glisser un
       voile est un geste de doigt ; a la souris on clique a cote, et armer
       volerait ce clic. Ici la souris est deja exclue par `auDoigt()` ; la
       ligne reste parce que le stylet, lui, passe. */
    var surVoile = !!cible.closest('.cmt-voile');
    if (surVoile && type === 'mouse') return false;
    var surPoignee = !!cible.closest('.cmt-tete') || surVoile;
    var scroller = corpsDefilant();
    var surCorps = !surPoignee && scroller && scroller.contains(cible);
    if (!surPoignee && !surCorps) return false;
    if (surCorps && scroller.scrollTop > 0) return false;

    glisse = true;
    arme = surPoignee;
    idPointeur = id;
    d0 = coord(x, y);
    t0 = t;
    trace.length = 0;
    echantillon(d0, t);
    if (surPoignee) {
      gesteArme();
      if (capture && panneau && panneau.setPointerCapture) {
        try {
          panneau.setPointerCapture(id);
        } catch (e) {
          /* capture refusee : le geste marche quand meme */
        }
      }
    }
    return true;
  }

  function gDecide(x, y, capture) {
    if (!glisse) return false;
    if (arme) return true;
    var dd = coord(x, y) - d0;
    /* Depuis le corps, on n'accapare le geste qu'une fois le seuil de tap
       franchi ET seulement dans le sens de la fermeture. */
    if (dd <= G_SLOP) {
      if (dd < -G_SLOP) glisse = false;
      return false;
    }
    /* RELU ICI, ET C'EST LE POINT QUI PROTEGE LE DEFILEMENT INTERNE : entre
       l'appui et le sixieme pixel, le doigt a pu faire descendre la liste. Un
       corps qui n'est plus en haut rend le geste au defilement. */
    var scroller = corpsDefilant();
    if (scroller && scroller.scrollTop > 0) {
      glisse = false;
      return false;
    }
    arme = true;
    gesteArme();
    if (capture && panneau && panneau.setPointerCapture) {
      try {
        panneau.setPointerCapture(idPointeur);
      } catch (e) {
        /* idem */
      }
    }
    return true;
  }

  function gPas(x, y, t, capture) {
    if (!gDecide(x, y, capture)) return false;
    var dd = coord(x, y) - d0;
    if (Math.abs(dd) > G_SLOP) bouge = true;
    echantillon(coord(x, y), t);
    gesteBouge(decalage(dd));
    return true;
  }

  function gFin(x, y, t, fermer) {
    if (!glisse) return;
    var etaitArme = arme;
    glisse = false;
    arme = false;
    try {
      if (idPointeur !== null && panneau && panneau.releasePointerCapture) {
        panneau.releasePointerCapture(idPointeur);
      }
    } catch (e) {
      /* deja relache */
    }
    idPointeur = null;
    gesteRepose();
    if (!etaitArme || !fermer) {
      trace.length = 0;
      return;
    }
    var dd = coord(x, y) - d0;
    var v = vitesse(coord(x, y), t);
    trace.length = 0;
    /* LA MEME PORTE QUE LA CROIX : `ferme()` sans argument, donc `depile()`,
       la restitution de l'adresse et le focus rendu au declencheur. */
    if (dd > 0 && (dd >= G_DISTANCE || Math.abs(v) > G_VELOCITY)) ferme();
  }

  function gAbandonne() {
    if (!glisse) return;
    glisse = false;
    arme = false;
    idPointeur = null;
    trace.length = 0;
    gesteRepose();
  }

  /* ── Le chemin du doigt ─────────────────────────────────────────────────
     Prioritaire sur celui du pointeur : c'est le seul qui peut dire non au
     defilement natif. `touchstart` en CAPTURE pour etre servi avant tout
     ecouteur de la page, `touchmove` NON PASSIF pour avoir le droit d'appeler
     `preventDefault()`.

     DEUX DOIGTS NE GLISSENT PAS UN TIROIR : c'est un pincement, et il
     appartient au navigateur (le zoom de page reste possible, regle
     d'accessibilite). */
  document.addEventListener('touchstart', function (e) {
    if (e.touches.length > 1) { gAbandonne(); return; }
    var t = e.touches[0];
    gDebut(e.target, t.clientX, t.clientY, e.timeStamp, 'touch', false, 'touch');
  }, true);

  document.addEventListener('touchmove', function (e) {
    if (!glisse) return;
    if (e.touches.length > 1) { gAbandonne(); return; }
    var t = e.touches[0];
    if (!gPas(t.clientX, t.clientY, e.timeStamp, false)) return;
    /* C'est ICI, et nulle part ailleurs, que le defilement natif et le rebond
       elastique de WebKit sont arretes. */
    if (e.cancelable) e.preventDefault();
  }, { passive: false, capture: true });

  document.addEventListener('touchend', function (e) {
    if (!glisse) return;
    var t = e.changedTouches[0];
    gFin(t ? t.clientX : 0, t ? t.clientY : d0, e.timeStamp, true);
  }, true);

  document.addEventListener('touchcancel', gAbandonne, true);

  /* ── Le chemin du pointeur ──────────────────────────────────────────────
     Il reste pour le stylet. Quand le doigt a deja pris le geste en charge,
     `gDebut` rend `true` sans rien refaire et `gPas` est idempotent : les deux
     chemins ne peuvent pas deplacer le panneau deux fois.

     `pointercancel` NE DECIDE RIEN : une annulation de WebKit pourrait sinon
     fermer un tiroir que le visiteur n'a pas lache. */
  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType === 'touch' && glisse) return;
    gDebut(e.target, e.clientX, e.clientY, e.timeStamp, e.pointerId, true, e.pointerType);
  }, true);

  document.addEventListener('pointermove', function (e) {
    if (!glisse || e.pointerId !== idPointeur) return;
    gPas(e.clientX, e.clientY, e.timeStamp, true);
  });

  function gFinPointeur(e) {
    if (!glisse) return;
    gFin(e.clientX, e.clientY, e.timeStamp, e.type === 'pointerup');
  }

  document.addEventListener('pointerup', gFinPointeur);
  document.addEventListener('pointercancel', gFinPointeur);

  /* ── Branchements ──────────────────────────────────────────────────────── */
  var decl = document.querySelectorAll('.cm-guide-tiroir-trigger');
  /* `iDecl`, et pas `d0` : `d0` est la coordonnee de depart du geste, quelques
     lignes plus haut. Cette boucle la remettait a `decl.length` au chargement.
     Sans consequence en pratique - `gDebut` reecrit `d0` a chaque appui avant
     de s'en servir - mais deux sens pour un nom dans une meme portee, c'est un
     defaut qui attend son jour (fix round 1 de la revue G10). */
  for (var iDecl = 0; iDecl < decl.length; iDecl++) {
    decl[iDecl].setAttribute('aria-haspopup', 'dialog');
    decl[iDecl].setAttribute('aria-controls', 'cm-guide-tailles');
    decl[iDecl].setAttribute('aria-expanded', 'false');
  }
  /* Delegation : le declencheur vit dans un composant qui peut se redessiner
     a chaque changement de variante, l'ecouteur vit sur le document et
     survit a tout. */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var t = e.target.closest('.cm-guide-tiroir-trigger');
    if (t) { e.preventDefault(); ouvre(t); return; }
    if (ouvert && e.target.closest('[data-cmt-fermer]')) {
      /* UN GLISSEMENT ANNULE NE DOIT PAS FERMER DEUX FOIS, NI FERMER TOUT
         COURT. Un glissement qui a ferme le tiroir ne laisse pas de `click`
         derriere lui ; un glissement ANNULE, lui, en laisse un, et le voile
         est justement une des trois zones qui arment le geste. Sans ce
         drapeau, un retour elastique parti du voile refermerait quand meme.
         Motif du panier (`casemira-cart.js`, lot I). */
      if (bouge && e.target.closest('.cmt-voile')) return;
      e.preventDefault();
      ferme();
    }
  });

  /* Etat de depart, calcule une seule fois, hors du chemin du clic. */
  meubleParDefaut();
  relit();
  mesureLaBarre();
  }

  /* ── LANCEMENT ────────────────────────────────────────────────────────────
     Le tiroir d'abord, parce qu'il porte la garde qui refuse de cohabiter avec
     le tiroir couloir ; la page ensuite, une instance par hote. Les deux ne se
     rencontrent jamais : une fiche produit n'a pas d'hote de page, et la page
     guide n'a pas de tiroir. */
  var tiroir = document.getElementById('cm-guide-tailles');
  if (tiroir) demarre(tiroir, 'tiroir');

  var hotes = document.querySelectorAll('[data-cmt-page]');
  for (var iH = 0; iH < hotes.length; iH++) demarre(hotes[iH], 'page');
})();
